import moment from "moment";
import { actionTypes, Types } from "../../context/action/action";
import store from "../../context/store/store";
import { chats, chatwindowDetails, contacts, contactwindowDetails, loginReducerState, LoginState, rightSidePanelDetails, UserDetails, workContact } from "../../models/model";
import { chatTeamValidation, checkInternet, generateChatID, savedChatListFraming, userInfo } from "./utils";
import { filterContact, filterContactForCallNew, filterGrpProfile, frameCallProfile, getCombinedNames, getCurrentCallDetail, getLocalAudioStream, handleStartRecording, redirect, setActiveLogs, setAiAssist, setUserStausInGroupCall, startCallTime, startCallTimeActiveLogs, startRecordTimer, toastInformation, updateOldWithNewObj, videoCallReqNotfy } from "../callService/common";
import { showBrowserNotification, showNotification } from "../notification";
import { SocketChatService } from ".";

import { compareName, Cookie, gifFormat, imageFormat, mp3Formats, strickerFormat, videoFormat, ConvertDuration, tempPushNotification, getCookie, closeVideoRinging, newTagUnread, getTimeDiffer, playNotificationSound } from "../utils";
import { getAllCounts, getCallLogsCDR, getRecordingLogs, getVoiceMailLogs, incomingCallDetail } from "../callService/callsApiService";
import { getMeetingByDate, getMeetingLists, getVideoRecordingLists, updateMeetingRead, updateMeetingTotalBatch } from "../meetingService/apiService";
import { storeActiveLogs, storeParticularLog } from "../callService/store_mining";
import { storeMeetingPage, storeWindowState } from "../meetingService/meetingStoreServices";
import _, { isEmpty } from "lodash";
import { currentCallEnd, detectActiveSpeaker, initiateCall, initiateFlipCall, muteGroupCall, sendDTMF } from "../callService/callService";
import { calldetail, currentCallDetail } from "../../models/callModel";
import { truncate } from "fs";
var hark = require('hark');
let condition:boolean=false;

export const groupChatDelivered = (socket: any, message: any) => { };
export function isJSON(str: any) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}
export const recentChatList = (socket: any, message: any) => {
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    try {
        //console.log(message?.settings,"message?.settings")
        if (message && message.users) {
            //let userIInfo: any = getCookie('userinfo');
            const userInfosess: any = sessionStorage.getItem("userinfo");
            let userIInfo: any = userInfosess;
            let parse = JSON.parse(userIInfo);
            //const fromUsers = parseInt(userInfo()?.fromID);
            const fromUsers = parse?.sip_login_id;
            const userId = message.users["s" + fromUsers];
            const settings = _.isUndefined(message?.settings);
            if (settings) {
                message.settings = {};
            }
            const isPinned = _.isUndefined(message?.settings?.isPinned);
            const isArchived = _.isUndefined(message?.settings?.isArchive);
            const isDeleted = _.isUndefined(message?.settings?.isDeleted);
            const isFavourite = _.isUndefined(message?.settings?.isFavourite);
            const isMarkRead = _.isUndefined(message?.settings?.markRead);
            if (isPinned) {
                message.settings.isPinned = {};
            }
            if (isArchived) {
                message.settings.isArchive = {};
            }
            if (isDeleted) {
                message.settings.isDeleted = {};
            }
            if (isFavourite) {
                message.settings.isFavourite = {};
            }
            if (isMarkRead) {
                message.settings.markRead = {};
            }
            const isPinnedParticipant = _.isUndefined(message?.settings?.isPinned?.["s" + fromUsers]);
            const isArchivedParticipant = _.isUndefined(message?.settings?.isArchive?.["s" + fromUsers]);
            const isDeletedParticipant = _.isUndefined(message?.settings?.isDeleted?.["s" + fromUsers]);
            const isFavouriteParticipant = _.isUndefined(message?.settings?.isFavourite?.["s" + fromUsers]);
            const isMarkReadParticipant = _.isUndefined(message?.settings?.markRead?.["s" + fromUsers]);
            const ismutestamp: any = (message?.settings?.muteTimeStamp?.["s" + fromUsers]);


            if (isPinnedParticipant) {
                message.settings.isPinned["s" + fromUsers] = 0;
            }
            if (isArchivedParticipant) {
                message.settings.isArchive["s" + fromUsers] = 0;
            }
            if (isFavouriteParticipant) {
                message.settings.isFavourite["s" + fromUsers] = 0;
            }
            if (isDeletedParticipant) {
                message.settings.isDeleted["s" + fromUsers] = 0;
            }
            if (isMarkReadParticipant) {
                message.settings.markRead["s" + fromUsers] = 0;
            }
            if (ismutestamp) {
                let mutetime = ismutestamp?.timeStamp !== "" ? getTimeDiffer(ismutestamp?.timeStamp) : ""
                if (ismutestamp !== "") {
                    if (mutetime < 0) {
                        const service = new SocketChatService(userInfo().fromID, userInfo().domainId);
                        let chatDetails = {
                            chatId: message?.chatId,
                            settingsKey: "isMuted",
                            muteTimestamp: "",
                            type: message?.type,
                            toSipId: message?.to,
                            status: 0
                        };
                        service.updateRecentChatSettings(chatDetails)
                    }
                }

            }

            if (userId) {
                message.to = userId;


                message.lastmsgText =
                    message?.lastmessage === ""
                      || Object.keys(message?.lastmessage.message || {}).length === 0
                        ? ""
                        : message?.lastmessage?.message?.messageType === "TEXT"
                            ? message?.lastmessage?.message?.body?.toString()
                            : message?.lastmessage?.message?.messageType === "image/gif"
                                ? "GIF" :
                                message?.lastmessage?.message?.messageType === "IMAGE" && message?.lastmessage?.message?.body?.fileType?.includes("gif")
                                    ? "GIF"
                                    : message?.lastmessage?.message?.messageType === "FILE" && videoFormat.indexOf(message?.lastmessage?.message?.body?.fileType) !== -1
                                        ? "Video"
                                        : message?.lastmessage?.message?.messageType === "FILE" && mp3Formats.indexOf(message?.lastmessage?.message?.body?.fileType) !== -1
                                            ? "Audio"
                                            : message?.lastmessage?.message?.messageType === "IMAGE"
                                                ? "IMAGE"
                                                : message?.lastmessage?.message?.messageType === "FILE" && videoFormat.indexOf(message?.lastmessage?.message?.body?.fileType) === -1 && mp3Formats.indexOf(message?.lastmessage?.message?.body?.fileType) === -1
                                                    ? "shared a file"
                                                    : message?.lastmessage?.message?.messageType === "GEO"
                                                        ? "Location"
                                                        : message?.lastmessage?.message?.messageType === "NOTE"
                                                            ? "Shared a notes"
                                                            : message?.lastmessage?.message?.messageType === "TASK"
                                                                ? "Shared a task"
                                                                : message?.lastmessage?.message?.messageType === "EVENTS"
                                                                    ? "Shared a events"
                                                                    : JSON.stringify(message?.lastmessage?.message?.body);
            }

            if (userId && fromUsers && (parseInt(userId) !== parseInt(fromUsers))) {
                store.dispatch({
                    type: actionTypes.RECENT_MESSAGE_LIST,
                    payload: {
                        recentChatList:
                            message.type === 2 ? { ["con" + userId]: message, ...recentChatList } : { [userId]: message, ...recentChatList },
                        recentLoading: false
                    }
                });

            }
            callDebounceFn();
        }
    } catch (e) {
        console.error("Error in Recent Chat List", e);

    }
    // const recentObjectList = [...message
    // ].filter(value=>{return value.to && value.from}).reduce((acc:any,curr:any) => {
    //     if(curr?.from){
    //         let test = curr.type === 2? "con"+curr["chatId"]: curr["to"];
    //       return ( acc[test]=curr,acc);
    //     }
    //   },{});
};

const callDebounceFn = _.debounce(() => {
    // console.log("Recent Chat Called !!!!");
    checkInternet(false);
    store.dispatch({
        type: actionTypes.RECENT_LOADING,
        payload: {
            recentLoading: true
        }
    });

}, 200)

export const clearRecentChat = (recent: boolean) => {
    store.dispatch({
        type: actionTypes.RECENT_MESSAGE_LIST,
        payload: {
            recentChatList: {},
            recentLoading: recent
        }
    });
};

export const saveHistoryMessage = (data: any) => {
    const archiveMessageArray = data.map((message: any) => {
        const fromUser = parseInt(message.from);
        let direction = "";
        if (fromUser !== parseInt(userInfo().fromID)) {
            direction = "IN";
        } else {
            direction = "OUT";
        }
        message.direction = direction;
        message['fromcaller_details'] = userInfo().workContactObj[fromUser];
        return message;
    });
    store.dispatch({
        type: actionTypes.MESSAGE_LIST,
        payload: {
            messageList: archiveMessageArray,
            messageLoading: false
        }
    });
};

export const historyChatList = (socket: any, chatRecord: any) => {
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    let { archiveID, messageList, scrollPos }: any = store.getState().chatSocketReducerState;
    let { recentChatList,historyLoading,historyFailedmsg }: any = store.getState().chatSocketRecentReducerState;
    let contactObject: any = store.getState().contactReducer;
    let chatRightSidePanelReducer: any = { ...store.getState().chatRightSidePanelReducer };
    const fileListDetails = [...chatRightSidePanelReducer.fileListDetails];
   
    try {
        // if (Array.isArray(chatRecord) && (chatWindowReducer?.chatWindowDetails?.chatId === chatRecord[0]?.chatId || chatWindowReducer?.isMySpace ) ) {
           if(Array.isArray(chatRecord)) {
        const archiveMessageArray = chatRecord.map((message:any) => {
                let direction = "";
                const fromUser = parseInt(message.from);
                //  const userDetailsnew = userInfo();
                //  const currUser = parseInt(userDetailsnew.fromID);
                //  const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";

                if (fromUser !== parseInt(userInfo().fromID)) {
                    if (parseInt(message.from) === parseInt(chatWindowReducer?.chatWindowDetails?.sip_login_id)) {
                        if (message?.readStatus !== 1 && message?.deliveryStatus === 8) {
                            newTagUnread(message);
                            socket.chatReadStatus(message);
                            // if (_.isUndefined(recentChatList?.[recentID]) === false) {
                            //     let unreadCount = recentChatList[recentID]?.unreadCount;
                            //     recentChatList[recentID].unreadCount = unreadCount - 1;
                            // }
                        } else {
                            if (Array.isArray(chatWindowReducer?.newTagMessage) && chatWindowReducer?.newTagMessage?.length > 0) {
                                store.dispatch({
                                    type: Types.NEW_TAG_MESSAGE,
                                    payload: {
                                        newTagMessage: []
                                    }
                                });
                            }
                        }
                    } else if (parseInt(message.from) !== parseInt(chatWindowReducer?.chatWindowDetails?.sip_login_id)) {
                        if (message.deliveryStatus !== 8) {
                            socket.chatDelivered(message);
                        }
                    }
                    direction = "IN";
                } else {
                    direction = "OUT";
                }
                message.direction = direction;

                if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
                    fileListDetails.push(message);
                }
                message.fromcaller_details = userInfo().workContactObj[fromUser] !== undefined ? userInfo().workContactObj[fromUser] : contactObject?.deleteContacts[fromUser];
                return message;
            });
            if (archiveMessageArray.length > 0) {
                store.dispatch({
                    type: Types.GET_FILES_LIST,
                    payload: {
                        isfile: true,
                        fileListDetails: fileListDetails
                    }
                });
            }
            // messageList: archiveID ? [...archiveMessageArray, ...messageList] : archiveMessageArray,
            if (archiveMessageArray.length > 0) {
               //console.log(messageList,archiveMessageArray.length,"00000009999999999")
                store.dispatch({
                    type: actionTypes.MESSAGE_LIST,
                    payload: {
                        messageList: archiveID ?  archiveMessageArray.concat(messageList)  : historyFailedmsg?.length>0 ? archiveMessageArray.concat(historyFailedmsg): archiveMessageArray,
                        messageLoading: archiveID ? false : false,
                        scrollPos: scrollPos,
                        archiveID: archiveID
                    }
                });
                if (chatWindowReducer.clearChatMsg !== "") {
                    let value = _.last(archiveMessageArray);
                    const userDetailsnew = userInfo();
                    const currUser = parseInt(userDetailsnew.fromID);
                    const recentID = parseInt(value?.from) !== currUser ? value?.from : parseInt(value?.to) !== currUser ? value?.to : "";
                    if (recentID) {
                        let msgText: any =
                            value?.message?.messageType === "TEXT"
                                ? value?.message?.body
                                : value?.message?.messageType === "IMAGE" && value?.message?.body?.fileType?.includes("gif")
                                    ? "GIF"
                                    : value?.message?.messageType === "FILE" && videoFormat.indexOf(value?.message?.body?.fileType) !== -1
                                        ? "Video"
                                        : value?.message?.messageType === "IMAGE"
                                            ? "IMAGE"
                                            : value?.message?.messageType === "FILE" && videoFormat.indexOf(value?.message?.body?.fileType) === -1
                                                ? "shared a file"
                                                : value?.message?.messageType === "GEO"
                                                    ? "Location"
                                                    : value?.message?.messageType === "NOTE"
                                                        ? "Shared a notes"
                                                        : value?.message?.messageType === "TASK"
                                                            ? "Shared a task"
                                                            : value?.message?.messageType === "EVENTS"
                                                                ? "Shared a events"
                                                                : JSON.stringify(value?.message?.body);
                        recentChatList[recentID].lastmessage = value;
                        recentChatList[recentID].lastmsgText = msgText;
                    }
                    store.dispatch({
                        type: Types.CHAT_CLEAR_MESSAGE,
                        payload: {
                            clearChatMsg: ''
                        }
                    })
                }
                store.dispatch({
                    type: actionTypes.RECENT_MESSAGE_LIST,
                    payload: {
                        recentChatList: recentChatList,
                        recentLoading: true
                    }
                });
            } else {
                store.dispatch({
                    type: actionTypes.UPDATE_ARCHIVEID,
                    payload: {
                        archiveID: "",
                        scrollPos: -1
                    }
                });

            }
            store.dispatch({
                type: actionTypes.HISTORY_LOADING,
                payload:{
                    historyLoading: true
                }
            })
            if (chatWindowReducer.clearChatMsg !== '' && archiveMessageArray.length === 0) {
                let clrValue: any = parseInt(chatWindowReducer?.chatWindowDetails?.sip_login_id)
                if (recentChatList[clrValue]) {
                    recentChatList[clrValue].lastmessage = '';
                    recentChatList[clrValue].lastmsgText = '';
                    store.dispatch({
                        type: actionTypes.RECENT_MESSAGE_LIST,
                        payload: {
                            recentChatList: recentChatList,
                            recentLoading: true
                        }
                    });
                }
                store.dispatch({
                    type: actionTypes.MESSAGE_LIST,
                    payload: {
                        messageList: []
                    }
                });
                store.dispatch({
                    type: Types.CHAT_CLEAR_MESSAGE,
                    payload: {
                        clearChatMsg: ''
                    }
                })
            }
        }
    } catch (e) {
        console.error("Error in History Chat List", e);
    }
};

export const createGroupchat = (socket: any, message: any) => {
    try {

        let { userdetails }: loginReducerState = store.getState().loginReducer;
        if (message.data) {
            let contactRed = store.getState().contactReducer;
            let { teamContacsnew, allContacs, teamContacs }: any = contactRed;

            let teamKey: any = message.data.team_id_prefix + message.data.team_id;
            allContacs.push(message.data);

            teamContacs.push(message.data);

            teamContacs.sort(compareName);

            Object.assign(teamContacsnew, { [teamKey]: message.data });
            store.dispatch({
                type: Types.TEAM_CONTACT_NEW,
                payload: {
                    teamContacsnew: teamContacsnew,
                    isTeamContactLoading: true
                }
            });

            store.dispatch({
                type: Types.TEAM_CONTACT,
                payload: {
                    teamContacs: teamContacs,
                    isTeamContactLoading: true
                }
            });
            store.dispatch({
                type: Types.ALL_CONTACT,
                payload: {
                    allContacs: allContacs
                }
            });
            chatTeamValidation(false);
            if (message.data?.created_by?.toString() === userdetails?.sip_login_id) {
                let allContacs: any = store.getState().contactReducer;
                const socketservice = new SocketChatService(userdetails?.sip_login_id, userdetails?.domain_id);
                let particularIndex: any = allContacs && allContacs?.allContacs?.findIndex((elem: any) => (elem.team_id === message.data.team_id));
                if (particularIndex !== -1) {
                    let teamcontactsDetail = allContacs?.allContacs[particularIndex];
                    socketservice.openChatWindow(teamcontactsDetail, '', '', 'newchat');
                }
                toastInformation("Success! Contact group created", "success");
            }
        } else {
            chatTeamValidation(true);
            toastInformation(message.status, "failure");
        }
    } catch (e) {
        console.error("Error in Create Group Chat", e);
    }
};


export const loginUpdate = () => {
    store.dispatch({
        type: actionTypes.SERVER_DISCONNECT,
        payload: {
            serverDisconnect: true
        }
    });
    setTimeout(() => {
        store.dispatch({
            type: actionTypes.SERVER_DISCONNECT,
            payload: {
                serverDisconnect: false
            }
        });
    }, 1000)
}
export const chatStatusUpdate = (message: any) => {
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let { messageList }: any = store.getState().chatSocketReducerState;
    try {
        const newMessageList = messageList.map((value: any) => {
            if (value.id === message.id) {
                // let newMessage = { ...value };
                value.deliveryStatus = message.deliveryStatus;
                value.readStatus = !message?.readStatus ? 0 : 1;
                return value;
            } else {
                return value;
            }
        });
        const userDetailsnew = userInfo();
        const currUser = parseInt(userDetailsnew.fromID);
        const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
        if (recentID && recentChatList[parseInt(recentID)]) {
            recentChatList[parseInt(recentID)].lastmessage = message;
            if (message?.deliveryStatus === 8 && message.readStatus === 1) {
                recentChatList[parseInt(recentID)].unreadCount = recentChatList[parseInt(recentID)].unreadCount > 0 ? recentChatList[parseInt(recentID)].unreadCount - 1 : 0;
            }
            store.dispatch({
                type: actionTypes.RECENT_MESSAGE_LIST,
                payload: {
                    recentChatList: recentChatList,
                    recentLoading: true
                }
            });
            store.dispatch({
                type: actionTypes.MESSAGE_LIST,
                payload: {
                    messageList: newMessageList,
                    messageLoading: false
                }
            });
        }
    } catch (e) {
        console.error("Error in Recent Chat List", e);

    }
};

export const bulkChatUpdate = (message:any) =>{
    
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let { messageList }: any = store.getState().chatSocketReducerState;
    let {isChatWindow, chatWindowDetails}: chatwindowDetails = store.getState().chatWindowReducer;

    var recentNewList:any= Object.values(recentChatList);

    try {
    recentNewList.forEach((value: any) => {
        
        if (value.chatId === message.chatId) {
           
            recentChatList[parseInt(value.to)].unreadCount = 0;
            recentChatList[parseInt(value.to)].lastmessage.readStatus=1;
         
        }  

    });
    if(isChatWindow && chatWindowDetails.chatId === message.chatId) {
        Array.isArray(messageList) && messageList.length > 0 && messageList.map((value: any) => {
            
            if (value.deliveryStatus === 8 && value.readStatus === 0 ) {
                // value.deliveryStatus = message.deliveryStatus;
                value.readStatus =  1;
                return value;
    
            } else {
                return value;
            }
        });
    }
  
    
    store.dispatch({
        type: actionTypes.RECENT_MESSAGE_LIST,
        payload: {
            recentChatList: recentChatList,
            recentLoading: true
        }
    });

    store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: messageList,
                messageLoading: false
            }
        });
   



} catch (e) {
    console.error("Error in Recent Chat List", e);

}
};

export const getRecentchatSaveList = (saveList: any) => {
    let contactObject: any = store.getState().contactReducer;
    if (contactObject.allContacs.length > 0) {
        updateRecentChatSaveList(saveList)
    } else {
        setTimeout(() => {
            updateRecentChatSaveList(saveList)
        }, 2000);
    }
};

export const updateRecentChatSaveList = (saveList: any) => {
    let framingSavingRecent: Array<object> = [];
    if (saveList.length > 0) {
        framingSavingRecent = saveList.map((value: any) => {
            return savedChatListFraming(value);
        });
    }
    store.dispatch({
        type: actionTypes.RECENT_SAVECHAT,
        payload: {
            savedChatList: saveList.length > 0 ? framingSavingRecent : []
        }
    });
}

export const chatStatusGroupUpdate = (message: any) => {
    try {
        if (message?.id) {
            let { messageList }: any = store.getState().chatSocketReducerState;
            let { recentChatList }: any = store.getState().chatSocketRecentReducerState;

            const newMessageList = messageList.map((value: any) => {
                if (value.id === message.id) {
                    value.deliveryStatus = message.deliveryStatus;
                    value.readStatus = !message?.readStatus ? 0 : 1;
                    return value;
                } else {
                    return value;
                }
            });
            const userDetailsnew = userInfo();
            if (message?.readreport &&
                _.isUndefined(message?.readreport["s" + userDetailsnew.fromID]) === false) {
                recentChatList["con" + message.chatId].unreadCount = 0;
            }
            if (message && message?.to) {
                let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
                if (recentChatList["con" + message?.chatId]) {
                    if (recentChatList["con" + message?.chatId]?.lastmessage) {
                        recentChatList["con" + message?.chatId].lastmessage.readStatus = message.readStatus
                        recentChatList["con" + message?.chatId].lastmessage.deliveryStatus = message.deliveryStatus
                        recentChatList["con" + message?.chatId].lastmessage.readreport = message.readreport;
                        recentChatList["con" + message?.chatId].lastmessage.deliveryreport = message.deliveryreport;
                    }
                }
            }
            store.dispatch({
                type: actionTypes.MESSAGE_LIST,
                payload: {
                    messageList: newMessageList
                }
            });
            store.dispatch({
                type: actionTypes.RECENT_MESSAGE_LIST,
                payload: {
                    recentChatList: recentChatList,
                    recentLoading: true
                }
            });
        }
    } catch (e) {
        console.error("Error in Group update", e);
    }
};
export const clearArchiveMessage = () => {
    store.dispatch({
        type: actionTypes.MESSAGE_LIST,
        payload: {
            messageList: [],
            messageLoading: false
        }
    });
    updateFileAttach([]);
    store.dispatch({
        type: actionTypes.UPDATE_ARCHIVEID,
        payload: {
            archiveID: ""
        }
    });
};
export const receivenewChat = (socket: any, message: any) => {
    let chatwindowDetails: any = store.getState().chatWindowReducer?.chatWindowDetails;
    let {scrollUnread,countValue}:chats=store.getState().chatReducer;
    let unreadCount_value = countValue+1;
    if (chatwindowDetails && message && chatwindowDetails.chatId && message.chatId) {
        if(chatwindowDetails?.chatId?.toString() === message?.chatId?.toString())
        {
            if(scrollUnread)
            {
                store.dispatch({
                    type: Types.COUNT_VALUE,
                    payload:{
                        countValue:unreadCount_value
                    }
                
                })
            }
        }
    }
   

    try {
        let { messageList, scrollPos, archiveID, messageExtraList }: any = store.getState().chatSocketReducerState;
        let { recentChatList,historyLoading }: any = store.getState().chatSocketRecentReducerState;
        let contactObject: any = store.getState().contactReducer;
        let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
        //let { userdetails }: any = store.getState().loginReducer;
        const archiveMessage = [...messageList];
        const archiveExtraMessage = [...messageExtraList];
        let direction = "";
        const fromUser = parseInt(message.from);
        //const toUser = parseInt(message.to);
        const userDetailsnew = userInfo();
        const currUser = parseInt(userDetailsnew.fromID);
        const recentID = fromUser !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
        const audio = new Audio(message?.message?.body?.filePath);
        let msgText: any =
            message?.message?.messageType === "TEXT"
                ? message?.message?.body
                : message?.message?.messageType === "IMAGE" && message?.message?.body?.fileType?.includes("gif")
                    ? "GIF"
                    : message?.message?.messageType === "FILE" && videoFormat.indexOf(message?.message?.body?.fileType) !== -1
                        ? "Video"
                        : message?.message?.messageType === "FILE" && mp3Formats.indexOf(message?.message?.body?.fileType) !== -1
                            ? "Audio"
                            : message?.message?.messageType === "IMAGE"
                                ? "IMAGE"
                                : message?.message?.messageType === "FILE" && videoFormat.indexOf(message?.message?.body?.fileType) === -1 && mp3Formats.indexOf(message?.message?.body?.fileType) === -1
                                    ? "shared a file"
                                    : message?.message?.messageType === "GEO"
                                        ? "Location"
                                        : message?.message?.messageType === "NOTE"
                                            ? "Shared a notes"
                                            : message?.message?.messageType === "TASK"
                                                ? "Shared a task"
                                                : message?.message?.messageType === "EVENTS"
                                                    ? "Shared a events"
                                                    : JSON.stringify(message?.message?.body);
        // console.log(message.from,"fromUser",chatWindowReducer.chatWindowDetails.sip_login_id,'chatWindowReducer.chatWindowDetails.sip_login_id',  parseInt(message.from) === chatWindowReducer.chatWindowDetails.sip_login_id);
        if (recentID) {
            if (
                fromUser !== currUser &&
                fromUser === parseInt(chatWindowReducer.chatWindowDetails.sip_login_id)
            ) {
                if (_.isUndefined(recentChatList[recentID]) === false) {
                    recentChatList[recentID].lastmessage = message;
                }
                if (message.deliveryStatus !== 8) {
                    socket.chatDelivered(message);
                    if (document.visibilityState === "visible" && window.location.pathname === '/chats') {
                        //console.log("tab receivechat active");
                        socket.chatReadStatus(message);
                    } else {
                        //console.log("tab receivechat inactive");
                        const fromCaller = contactObject.workContactsnew[recentID];
                        let inputOptions = {
                            userName: fromCaller?.caller_id,
                            message: message,
                            id: fromCaller
                        };
                        if (!fromCaller?.is_muted) {
                        if (document.visibilityState === "visible" && window.location.pathname !== '/chats') {
                            playNotificationSound()
                        } else {
                            chatNotificationFlow(inputOptions, '');
                        }
                    }
                    }
                }
                if (message?.readStatus !== 1) {

                    if (document.visibilityState === "visible" && window.location.pathname === '/chats') {
                        recentChatList[recentID].lastmessage = message;
                        recentChatList[recentID].lastmsgText = msgText;
                        if (_.isUndefined(recentChatList[recentID]) === false) {
                            const unreadCount =
                                recentChatList[recentID].unreadCount !== 0 && recentChatList[recentID].unreadCount > 0
                                    ? parseInt(recentChatList[recentID].unreadCount) - 1
                                    : 0;
                            recentChatList[recentID].unreadCount = unreadCount;
                        }
                    } else {
                        if (recentChatList[recentID]?.settings?.markRead?.["s" + fromUser] === 1) {
                            recentChatList[recentID].settings.markRead["s" + fromUser] = 0;
                            recentChatList[recentID].lastmessage = message;
                            recentChatList[recentID].lastmsgText = msgText;
                        }
                        if (_.isUndefined(recentChatList[recentID]) === false) {
                            const unreadCount =
                                recentChatList[recentID].unreadCount !== 0 && recentChatList[recentID].unreadCount > 0
                                    ? parseInt(recentChatList[recentID].unreadCount) + 1
                                    : 1;
                            recentChatList[recentID].unreadCount = unreadCount;
                            recentChatList[recentID].lastmessage = message;
                            recentChatList[recentID].lastmsgText = msgText;
                            const fromID = currUser;
                            if (recentChatList[recentID]?.settings?.markRead["s" + fromID] === 2) {
                                const service = new SocketChatService(userInfo().fromID, userInfo().domainId);
                                let chatDetails = {
                                    chatId: recentChatList[recentID]?.chatId,
                                    settingsKey: "markRead",
                                    status: 0
                                }
                                service.updateRecentChatSettings(chatDetails)
                            }
                        }
                    }
                }
                direction = "IN";
            } else if (
                fromUser !== currUser &&
                fromUser !== parseInt(chatWindowReducer.chatWindowDetails.sip_login_id)
            ) {
                if (recentChatList[recentID]?.settings?.markRead?.["s" + fromUser] === 1) {
                    recentChatList[recentID].settings.markRead["s" + fromUser] = 0;
                    recentChatList[recentID].lastmessage = message;
                    recentChatList[recentID].lastmsgText = msgText;
                }
                direction = "IN";
                if (message.deliveryStatus !== 8) {
                    socket.chatDelivered(message);
                    if (_.isUndefined(recentChatList[recentID]) === false) {
                        const unreadCount =
                            recentChatList[recentID].unreadCount !== 0 && recentChatList[recentID].unreadCount > 0
                                ? parseInt(recentChatList[recentID].unreadCount) + 1
                                : 1;
                        recentChatList[recentID].unreadCount = unreadCount;
                        recentChatList[recentID].lastmessage = message;
                        recentChatList[recentID].lastmsgText = msgText;
                        const fromID = currUser;
                        if (recentChatList[recentID]?.settings?.markRead["s" + fromID] === 2) {
                            const service = new SocketChatService(userInfo().fromID, userInfo().domainId);
                            let chatDetails = {
                                chatId: recentChatList[recentID]?.chatId,
                                settingsKey: "markRead",
                                status: 0
                            }
                            service.updateRecentChatSettings(chatDetails)
                        }
                    }
                }
                const fromCaller = contactObject.workContactsnew[recentID];
                let inputOptions = {
                    userName: fromCaller?.caller_id,
                    message: message,
                    id: fromCaller
                };

                var currentTimestamp = moment().valueOf();
                if (fromCaller?.is_muted && fromCaller?.mute_timestamp) {
                    if (parseInt(fromCaller?.mute_timestamp) < currentTimestamp) {
                       // chatNotificationFlow(inputOptions, '');
                    }
                } else if (!fromCaller?.is_muted) {
                    if (document.visibilityState === "visible") {
                        //console.log("tab receivechat active");
                        if ((mp3Formats.indexOf(message?.message?.body?.fileType) !== -1 || videoFormat.indexOf(message?.message?.body?.fileType) !== -1) && message?.message?.messageType === "FILE") {
                            audio.addEventListener("loadedmetadata", function () {
                                const fromCaller = contactObject.workContactsnew[recentID];
                                let duration_set = ConvertDuration(audio.duration);
                                //console.log('duration with audio ---->', duration_set);
                                let inputOptions = {
                                    userName: fromCaller?.caller_id,
                                    message: message,
                                    id: fromCaller
                                };
                                chatNotificationFlow(inputOptions, duration_set);
                                //return ConvertDuration(duration_audio);
                            });
                        }
                        else {
                            playNotificationSound()
                            //chatNotificationFlow(inputOptions,'');
                        }
                    } else {
                        let inputOptions = {
                            userName: fromCaller?.caller_id,
                            message: message,
                            id: fromCaller
                        };
                        chatNotificationFlow(inputOptions, '');
                    }
                }
                if (recentChatList?.[recentID]) {
                    recentChatList[recentID].lastmsgText = msgText;
                    recentChatList[recentID].createdAt = message.createdAt;
                    recentChatList[recentID].updatedAt = message.updatedAt;
                    recentChatList[recentID].lastmessage = message;
                    recentChatList[recentID].timestamp = message.timestamp;                  
                }
            } else {
                if (_.isUndefined(recentChatList?.[recentID])) {
                    direction = "OUT";
                    const initialObj = {
                        chatId: message.chatId,
                        createdAt: new Date().toISOString(),
                        from: message.from,
                        id: message.id,
                        lastmsgText: msgText,
                        to: message.to,
                        timestamp: message.timestamp,
                        lastmessage: message,
                        type: message.type,
                        updatedAt: new Date().toISOString(),
                        unreadCount: 0
                    };
                    recentChatList[recentID] = initialObj;
                }
                if (recentChatList[recentID]) {
                    recentChatList[recentID].createdAt = message.createdAt;
                    recentChatList[recentID].updatedAt = message.updatedAt;
                    recentChatList[recentID].timestamp = message.timestamp;
                    recentChatList[recentID].lastmessage = message;
                    recentChatList[recentID].lastmsgText = msgText;
                }
                direction = "OUT";
            }
            const fromID = currUser;
            let userDetails: any = recentChatList[recentID];
            if (_.isUndefined(recentChatList[recentID])) {
                const initialObj = {
                    chatId: message.chatId,
                    createdAt: new Date().toISOString(),
                    from: message.from,
                    id: message.id,
                    lastmsgText: msgText,
                    to: message.from,
                    timestamp: message.timestamp,
                    lastmessage: message,
                    type: message.type,
                    updatedAt: new Date().toISOString(),
                    unreadCount: 1
                };
                userDetails = { ...initialObj };
                recentChatList[recentID] = initialObj;
            }

            const settings = _.isUndefined(userDetails?.settings);
            const recentChatUser = userDetails;
            if (settings) {
                recentChatUser.settings = {};
            }
            const isPinned = _.isUndefined(recentChatUser?.settings?.isPinned);
            const isArchived = _.isUndefined(recentChatUser?.settings?.isArchive);
            const isDeleted = _.isUndefined(recentChatUser?.settings?.isDeleted);
            const isMuted = _.isUndefined(recentChatUser?.settings?.isMuted);
            const markRead = _.isUndefined(recentChatUser?.settings?.markRead);
            const isFavourite = _.isUndefined(recentChatUser?.settings?.isFavourite);
            if (isPinned) {
                recentChatUser.settings.isPinned = {};
            }
            if (isArchived) {
                recentChatUser.settings.isArchive = {};
            }
            if (isDeleted) {
                recentChatUser.settings.isDeleted = {};
            }
            if (isMuted) {
                recentChatUser.settings.isMuted = {};
            }
            if (isFavourite) {
                recentChatUser.settings.isFavourite = {};
            }
            if (markRead) {
                recentChatUser.settings.markRead = {};
            }
            const isPinnedParticipant = _.isUndefined(recentChatUser?.settings?.isPinned?.["s" + fromID]);
            const isArchivedParticipant = _.isUndefined(recentChatUser?.settings?.isArchive?.["s" + fromID]);
            const isDeletedParticipant = _.isUndefined(recentChatUser?.settings?.isDeleted?.["s" + fromID]);
            const isFavouriteParticipant = _.isUndefined(recentChatUser?.settings?.isFavourite?.["s" + fromID]);
            const isMutedParticipant = _.isUndefined(recentChatUser?.settings?.isMuted?.["s" + fromID]);
            const isMarkParticipant = _.isUndefined(recentChatUser?.settings?.markRead?.["s" + fromID]);
            if (isPinnedParticipant) {
                recentChatUser.settings.isPinned["s" + fromID] = 0;
            }
            if (isArchivedParticipant) {
                recentChatUser.settings.isArchive["s" + fromID] = 0;
            }
            if (isDeletedParticipant) {
                recentChatUser.settings.isDeleted["s" + fromID] = 0;
            }
            if (isFavouriteParticipant) {
                recentChatUser.settings.isFavourite["s" + fromID] = 0;
            }
            if (isMutedParticipant) {
                recentChatUser.settings.isMuted["s" + fromID] = 0;
            }
            if (isMarkParticipant) {
                recentChatUser.settings.markRead["s" + fromID] = 0;
            }
            if (recentChatUser.settings.isDeleted["s" + fromID] === 1) {
                recentChatUser.settings.isDeleted["s" + fromID] = 0;
            }

            recentChatList[recentID] = recentChatUser;
            let cookieData: any;
            const userInfoData: any = Cookie.get();
            const userInfosess: any = sessionStorage.getItem("userinfo");

            if (userInfosess && userInfoData["ssoToken"]) {
                cookieData = JSON.parse(userInfosess);
            }

            let chatDetail = { chatId: generateChatID(cookieData?.sip_login_id?.toString(), chatWindowReducer?.chatWindowDetails?.sip_login_id?.toString()) };
            if (chatDetail && chatDetail?.chatId === message?.chatId) {
                let parse: any =
                    message?.message?.messageType === "TASK" || message?.message?.messageType === "EVENTS"
                        ? JSON.stringify(message?.message?.body)
                        : "";

                let msg: any =
                    message?.message?.messageType === "NOTE"
                        ? message.message.body
                        : message?.message?.messageType === "TASK" || message?.message?.messageType === "EVENTS"
                            ? JSON.parse(parse)
                            : message.message.body;
                message.message.body = msg;
                message.direction = direction;
                message.fromcaller_details = contactObject.workContactsnew[fromUser];
                const findIndex = archiveMessage.findIndex((value: any) => value?.id === message.id);
                const findExtraIndex = archiveExtraMessage.findIndex((value: any) => value?.id === message.id);
                if (findIndex > -1) {
                    archiveMessage[findIndex] = message;
                } else {
                    archiveMessage.push(message);
                }
               
                if(!historyLoading){
                    store.dispatch({
                        type:actionTypes.HISTORY_LOADING,
                        payload:{
                            historyFailedmsg: archiveMessage
                        }
                    })
                }
                if (chatWindowReducer?.fileOpenMessage) {
                    if (findExtraIndex > -1) {
                        archiveExtraMessage[findExtraIndex] = message;
                    } else {
                        archiveExtraMessage.push(message);
                    }
                }
                //console.log(message,'message --->',archiveMessage)

                if (chatWindowReducer?.fileOpenMessage) {
                    store.dispatch({
                        type: actionTypes.MESSAGE_EXTRALIST,
                        payload: {
                            messageExtraList: archiveExtraMessage
                        }
                    })
                } else {
                    store.dispatch({
                        type: actionTypes.MESSAGE_LIST,
                        payload: {
                            messageList: archiveMessage,
                            fileUploadingStatus: false,
                            archiveID: message.direction === "IN" ? archiveID : "",
                            scrollPos: message.direction === "IN" ? scrollPos : 0
                        }
                    });

                }
                if (message.direction !== "IN" && (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE")) {
                    store.dispatch({
                        type: actionTypes.PROGRESS_COMPLETE,
                        payload: {
                            progressComplete: true
                        }
                    });
                    setTimeout(() => {
                        store.dispatch({
                            type: actionTypes.PROGRESS_COMPLETE,
                            payload: {
                                progressComplete: false
                            }
                        });
                    }, 1000);
                }



            }
            store.dispatch({
                type: actionTypes.RECENT_MESSAGE_LIST,
                payload: {
                    recentChatList: recentChatList,
                    recentLoading: true
                }
            });
        } else {
            let cookieData: any;
            const userInfoData: any = Cookie.get();
            const userInfosess: any = sessionStorage.getItem("userinfo");

            if (userInfosess && userInfoData["ssoToken"]) {
                cookieData = JSON.parse(userInfosess);
            }

            let chatDetail = { chatId: generateChatID(cookieData?.sip_login_id?.toString(), chatWindowReducer?.chatWindowDetails?.sip_login_id?.toString()) };
            if (message?.chatId === chatDetail?.chatId) {
                message.direction = "OUT";
                message.fromcaller_details = contactObject.workContactsnew[fromUser];
                const findIndex = archiveMessage.findIndex((value: any) => value?.id === message.id);
                if (findIndex > -1) {
                    archiveMessage[findIndex] = message;
                } else {
                    archiveMessage.push(message);
                }

                if (chatWindowReducer?.fileOpenMessage) {
                    store.dispatch({
                        type: actionTypes.MESSAGE_EXTRALIST,
                        payload: {
                            messageExtraList: archiveExtraMessage
                        }
                    })
                } else {
                    store.dispatch({
                        type: actionTypes.MESSAGE_LIST,
                        payload: {
                            messageList: archiveMessage,
                            fileUploadingStatus: false,
                            archiveID: message.direction === "IN" ? archiveID : "",
                            scrollPos: message.direction === "IN" ? scrollPos : 0
                        }
                    });
                }
            }
            let chatRightSidePanelReducer: any = { ...store.getState().chatRightSidePanelReducer };
            if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
                const fileListDetails = [...chatRightSidePanelReducer.fileListDetails];
                fileListDetails.push(message);
                store.dispatch({
                    type: Types.GET_FILES_LIST,
                    payload: {
                        isfile: true,
                        fileListDetails: fileListDetails
                    }
                });
            }

            if (chatWindowReducer?.fileOpenMessage) {
                store.dispatch({
                    type: actionTypes.MESSAGE_EXTRALIST,
                    payload: {
                        messageExtraList: archiveExtraMessage
                    }
                })
            } else {
                store.dispatch({
                    type: actionTypes.MESSAGE_LIST,
                    payload: {
                        messageList: archiveMessage,
                        fileUploadingStatus: false,
                        archiveID: message.direction === "IN" ? archiveID : "",
                        scrollPos: message.direction === "IN" ? scrollPos : 0
                    }
                });
            }
        }
        let chatRightSidePanelReducer: any = { ...store.getState().chatRightSidePanelReducer };
        if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
            const fileListDetails = [...chatRightSidePanelReducer.fileListDetails];
            fileListDetails.push(message);
            store.dispatch({
                type: Types.GET_FILES_LIST,
                payload: {
                    isfile: true,
                    fileListDetails: fileListDetails
                }
            });
        }

        if (message?.message?.isLink) {
            const linksArray = [...chatRightSidePanelReducer.linkListDetails];
            const linklistMessage = savedChatListFraming(message);
            linksArray.unshift(linklistMessage);
            store.dispatch({
                type: Types.GET_LINK_LIST,
                payload: {
                    isLink: true,
                    linkListDetails: linksArray
                }
            });
        }
        if (message?.message?.messageType === "NOTE" || message?.message?.messageType === "TASK" || message?.message?.messageType === "EVENTS") {

            store.dispatch({
                type: Types.CONTACT_TASK_UPDATE,
                payload: {
                    isTaskUpdate: true
                }
            });
            //ChatService.taskList('task');
        }

        if (message?.message?.isReply === true) {
            tempPushNotification(message);
        }

    } catch (e) {
        console.error("Error in Receive New Chat", e);
    } finally {
    }
};

export const addMessage = () => { };

export const NewDraftNotSelected = (history: any) => {
    // setNewMessage(true);
    history.push("/chats");

    store.dispatch({
        type: Types.OPEN_NEW_MESSAGE,
        payload: {
            isNewMessageWindow: true,
            newUserMessage: [],
            newUserDetails: []
        }
    });

    store.dispatch({
        type: Types.UPDATE_TEAM_MEMBER,
        payload: {
            newUserMembers: []
        }
    });

    store.dispatch({
        type: Types.MULTI_NEWMESSAE,
        payload: {
            isMultiNewUserchat: false,
            multiMemberList: []
        }
    });

    clearArchiveMessage();

    store.dispatch({
        type: Types.STORE_ARCHIVE_MESSAGE,
        payload: {
            archiveMessageArray: []
        }
    });
    store.dispatch({
        type: Types.OPEN_CHAT_WINDOW,
        payload: {
            isChatWindow: false,
            isNewMessageWindow: true,
            chatWindowDetails: {}

        }
    });
};

export const updateFileAttach = (filesinfoArray: any) => {
    store.dispatch({
        type: actionTypes.FILE_ATTACHMENTS,
        payload: {
            filesAttach: filesinfoArray
        }
    });
};

export const updateRecentChatSettings = (socket: any, message: any, typeId?: any) => {
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;

    try {
        if (message.users) {
            const userDetails = userInfo();
            const fromUser = parseInt(userDetails.fromID);
            const settings = _.isUndefined(message?.settings);
            if (settings) {
                message.settings = {};
            }

            const isPinned = _.isUndefined(message?.settings?.isPinned);
            const isArchived = _.isUndefined(message?.settings?.isArchive);
            const isDeleted = _.isUndefined(message?.settings?.isDeleted);
            const isFavourited = _.isUndefined(message?.settings?.isFavourite);
            const isMuted = _.isUndefined(message?.settings?.isMuted);
            const isMarkRead = _.isUndefined(message?.settings?.markRead);

            if (isPinned) {
                message.settings.isPinned = {};
            }
            if (isArchived) {
                message.settings.isArchive = {};
            }
            if (isMarkRead) {
                message.settings.markRead = {};
            }
            if (isDeleted) {
                message.settings.isDeleted = {};
            }
            if (isFavourited) {
                message.settings.isFavourite = {};
            }
            if (isMuted) {
                message.settings.isMuted = {};
            }
            const isPinnedParticipant = _.isUndefined(message?.settings?.isPinned?.["s" + fromUser]);
            const isArchivedParticipant = _.isUndefined(message?.settings?.isArchive?.["s" + fromUser]);
            const isDeletedParticipant = _.isUndefined(message?.settings?.isDeleted?.["s" + fromUser]);
            const isFavouriteParticipant = _.isUndefined(message?.settings?.isFavourite?.["s" + fromUser]);
            const isMutedParticipant = _.isUndefined(message?.settings?.isMuted?.["s" + fromUser]);
            const isMarkParticipant = _.isUndefined(message?.settings?.markRead?.["s" + fromUser]);

            if (isPinnedParticipant) {
                message.settings.isPinned["s" + fromUser] = 0;
            }
            if (isArchivedParticipant) {
                message.settings.isArchive["s" + fromUser] = 0;
            }
            if (isDeletedParticipant) {
                message.settings.isDeleted["s" + fromUser] = 0;
            }
            if (isFavouriteParticipant) {
                message.settings.isFavourite["s" + fromUser] = 0;
            }
            if (isMutedParticipant) {
                message.settings.isMuted["s" + fromUser] = 0;
            }
            if (isMarkParticipant) {
                message.settings.markRead["s" + fromUser] = 0;
            }

            if (message.type === 1 && message?.users) {
                const fromUsers = parseInt(userInfo().fromID);
                const userId = message.users["s" + fromUsers];
                let { teamContacsnew }: any = store.getState().contactReducer;
                if (recentChatList[userId]) {
                    recentChatList[userId].settings = message.settings;
                }

                if (message?.settingsKey === "isDeleted") {
                    let { workContactsnew }: any = store.getState().contactReducer;
                    const socketService = new SocketChatService(userInfo().fromID, userInfo().domainId);

                    if (_.isUndefined(workContactsnew[userId]) === false) {
                        // .next()
                        const index = Object.keys(recentChatList).indexOf(userId);
                        if (index > -1) {

                            var result = _.chain(Object.values(recentChatList))
                                .sortBy((item: any) => item.lastmessage.timestamp, ['desc']).reverse().flatten()
                                .value();

                            //const newFindIndex = result.findIndex((value: any) => value.to === parseInt(userId));
                            const newFindIndex = result.findIndex((value: any) => value.chatId === message.chatId);
                            const newIndex: any = result[newFindIndex + 1];
                            if (newIndex && newIndex?.to && (teamContacsnew?.["con" + newIndex?.to] || workContactsnew?.[newIndex?.to])) {
                                socketService.openChatWindow(newIndex.type === 2 ? teamContacsnew["con" + newIndex?.to] :
                                    workContactsnew[newIndex?.to], "", newIndex);
                            }
                            if (recentChatList[userId]) {
                                recentChatList[userId].lastmsgText = ''
                                recentChatList[userId].lastmessage = ''
                            }
                        }

                    }
                }
                if (message?.settingsKey === "isMuted") {
                    let { workContacts, teamContacs, allContacs, workContactsnew, teamContacsnew, favContacts }: any = store.getState().contactReducer;
                    let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
                    let allContacts = Array.isArray(allContacs) ? allContacs : [];
                    const allindex = allContacs.findIndex((value: any) => {
                        return value?.sip_login_id?.toString() === userId?.toString()
                    });
                    const workIndex = workContacts.findIndex((value: any) => value?.sip_login_id?.toString() === userId?.toString());
                    const favContactIndex: any = Array.isArray(favContacts) && favContacts.length > 0 ?
                        favContacts.findIndex((value: any) => value?.sip_login_id === userId) : -1;

                    if (allindex > -1 && workIndex > -1) {
                        allContacts[allindex].is_muted = message?.settings?.isMuted["s" + fromUsers];
                        allContacts[allindex].mute_timestamp = message?.settings?.muteTimeStamp?.["s" + fromUsers]?.timeStamp;
                        workContactsnew[userId].is_muted = message?.settings?.isMuted["s" + fromUsers];
                        workContactsnew[userId].mute_timestamp = message?.settings?.muteTimeStamp?.["s" + fromUsers]?.timeStamp;
                        // teamContacs[allindex].is_favourite= isFavourite;
                        // console.log("favContacts[favContactIndex]-----", favContacts[favContactIndex]);
                        if (favContactIndex !== -1) {
                            favContacts[favContactIndex].is_muted = message?.settings?.isMuted["s" + fromUsers];
                        }
                        workContacts[workIndex].is_muted = message?.settings?.isMuted["s" + fromUsers];
                        workContacts[workIndex].mute_timestamp = message?.settings?.muteTimeStamp?.["s" + fromUsers]?.timeStamp;
                        store.dispatch({
                            type: Types.UPDATE_ALL_CONTACTS,
                            payload: {
                                teamContacsnew: teamContacsnew,
                                teamContacs: teamContacs,
                                workContacts: workContacts,
                                workContactsnew: workContactsnew,
                                allContacs: allContacs
                            }
                        });
                        store.dispatch({
                            type: Types.FAV_CONTACT,
                            payload: { favContacts: favContacts }
                        });
                        if (chatWindowReducer?.chatWindowDetails?.sip_login_id?.toString() === userId?.toString()) {
                            store.dispatch({
                                type: Types.SET_CONTACT_WINDOW,
                                payload: {
                                    chatWindowDetails: workContactsnew[userId]
                                }
                            });
                        }
                        if (window.location.pathname === '/calls') {
                            let { particularLog, logs }: any = store.getState().callReducer || {};
                            particularLog['is_muted'] = message?.settings?.isMuted["s" + fromUsers];
                            particularLog['mute_timestamp'] = message?.settings?.muteTimeStamp?.["s" + fromUsers]?.timeStamp;
                            if ((message.toSipId).toString() === (particularLog?.sip_login_id).toString()) { storeParticularLog(particularLog, false); }
                            logs.forEach((logEle: any) => {
                                if ((logEle.sip_login_id).toString() === (message.toSipId).toString()) {
                                    logEle['is_muted'] = message?.settings?.isMuted["s" + fromUsers];
                                    logEle['mute_timestamp'] = message?.settings?.muteTimeStamp?.["s" + fromUsers]?.timeStamp;
                                }
                            });
                        }

                        if (contactWindowDetails.sip_login_id === userId) {
                            contactWindowDetails.is_muted = message?.settings?.isMuted["s" + fromUsers];
                            // openContactWindowRedux(isContactWindow,contactWindowDetails,false); 
                        }
                    }
                }
                if(message?.settingsKey === "markRead"){
                  updateSettingStatus(message?.type, message?.type === 1 ? message?.users["s" + fromUsers] : message?.chatId, message?.settings);
                }
            } else {
                if (recentChatList?.["con" + message?.chatId]) {
                    recentChatList["con" + message.chatId].settings = message.settings;
                    if (message?.settingsKey === "isDeleted") {
                        let { teamContacsnew }: any = store.getState().contactReducer;
                        const userId = message.chatId;
                        const socketService = new SocketChatService(userInfo().fromID, userInfo().domainId);
                        if (_.isUndefined(teamContacsnew["con" + userId]) === false && typeId !== 3) {
                            socketService.openChatWindow(teamContacsnew["con" + userId], "");
                        }
                        recentChatList["con" + message.chatId].lastmessage = ''
                        recentChatList["con" + message.chatId].lastmsgText = ''

                    }
                }

                if (message?.settingsKey === "isMuted") {
                    let { workContacts, teamContacs, allContacs, workContactsnew, teamContacsnew, favContacts }: any = store.getState().contactReducer;
                    let { contactWindowDetails, isContactWindow }: contactwindowDetails = store.getState().contactWindowReducer;
                    const allindex = allContacs.findIndex((value: any) => parseInt(value.team_id) === parseInt(message?.chatId));
                    const teamindex = teamContacs.findIndex((value: any) => parseInt(value.team_id) === parseInt(message?.chatId));
                    const favContactIndex = (Array.isArray(favContacts) && favContacts.length > 0) ?
                        favContacts.findIndex((value: any) => parseInt(value.team_id) === parseInt(message?.chatId)) : -1;
                    let allContacts = Array.isArray(allContacs) ? allContacs : [];
                    const allContactsDetails = allContacts[allindex];
                    const teamid = allContactsDetails?.team_id;
                    allContacs[allindex].team_members_muted = message?.team_members_muted;
                    teamContacs[teamindex].team_members_muted = message?.team_members_muted;
                    teamContacsnew["con" + teamid].team_members_muted = message?.team_members_muted;
                    if (favContactIndex > -1) {
                        favContacts[favContactIndex].team_members_muted = message?.team_members_muted;
                    }
                    store.dispatch({
                        type: Types.FAV_CONTACT,
                        payload: { favContacts: favContacts }
                    });

                    store.dispatch({
                        type: Types.UPDATE_ALL_CONTACTS,
                        payload: {
                            teamContacsnew: teamContacsnew,
                            teamContacs: teamContacs,
                            workContacts: workContacts,
                            workContactsnew: workContactsnew,
                            allContacs: allContacs
                        }
                    });
                    if (chatWindowReducer?.chatWindowDetails?.team_id === teamid) {
                        let data: any = chatWindowReducer?.chatWindowDetails;
                        data.team_members_muted = message?.team_members_muted;
                        store.dispatch({
                            type: Types.SET_CONTACT_WINDOW,
                            payload: {
                                chatWindowDetails: data
                            }
                        });
                        //  openContactWindowRedux(isContactWindow,teamContacsnew["con"+teamid],false);   
                    }
                    if (contactWindowDetails?.team_id === teamid) {
                        contactWindowDetails.team_members_muted = message?.team_members_muted;
                        openContactWindowRedux(isContactWindow, contactWindowDetails, false);
                    }


                }
                if(message?.settingsKey === "markRead"){
                    updateSettingStatus(message?.type, message?.type === 1 ? message?.users["s" + fromUser] : message?.chatId, message?.settings);
                }
            }

            store.dispatch({
                type: actionTypes.RECENT_MESSAGE_LIST,
                payload: {
                    recentChatList: recentChatList,
                    recentLoading: true
                }
            });
        }

        if (message?.settingsKey === "isFavourite") {
            const phoneNumber = message?.phoneNumber;
            let { workContacts, teamContacs, allContacs, workContactsnew, teamContacsnew }: any = store.getState().contactReducer;
            let { contactWindowDetails, isContactWindow }: contactwindowDetails = store.getState().contactWindowReducer;
            let allContacts = Array.isArray(allContacs) ? allContacs : [];
            if (phoneNumber) {
                const allindex = allContacs.findIndex((value: any) => value.ext === phoneNumber);
                const workIndex = workContacts.findIndex((value: any) => value.ext === phoneNumber);
                const fromUsers = parseInt(userInfo().fromID);

                if (allindex > -1 && workIndex > -1) {
                    //let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
                    const allContactsDetails = allContacts[allindex];

                    if (message?.type === 1) {
                        const sipid = allContactsDetails?.sip_login_id;
                        if (
                            sipid
                        ) {
                            const isFavourite = message?.settings?.isFavourite["s" + fromUsers];
                            if (
                                _.isUndefined(allContacts[allindex]) === false &&
                                _.isUndefined(workContacts[workIndex]) === false &&
                                _.isUndefined(workContactsnew[sipid]) === false
                            ) {
                                allContacts[allindex].is_favourite = isFavourite;
                                workContactsnew[sipid].is_favourite = isFavourite;
                                // teamContacs[allindex].is_favourite= isFavourite;
                                workContacts[workIndex].is_favourite = isFavourite;

                                store.dispatch({
                                    type: Types.UPDATE_ALL_CONTACTS,
                                    payload: {
                                        teamContacsnew: teamContacsnew,
                                        teamContacs: teamContacs,
                                        workContacts: workContacts,
                                        workContactsnew: workContactsnew,
                                        allContacs: allContacs
                                    }
                                });

                                if (window.location.pathname === '/calls') {
                                    let { particularLog, logs }: any = store.getState().callReducer || {};
                                    particularLog['is_favourite'] = isFavourite;

                                    // eslint-disable-next-line max-depth
                                    if ((message.toSipId).toString() === (particularLog.sip_login_id).toString()) {
                                        storeParticularLog(particularLog, false);
                                    }
                                    logs.forEach((logEle: any) => {
                                        console.log('logEle', logEle)
                                        if ((logEle?.sip_login_id).toString() === (message?.toSipId).toString()) {
                                            logEle['is_favourite'] = isFavourite;
                                        }
                                    });
                                }
                                if (chatWindowReducer?.chatWindowDetails?.sip_login_id === sipid) {
                                    store.dispatch({
                                        type: Types.SET_CONTACT_WINDOW,
                                        payload: {
                                            chatWindowDetails: workContactsnew[sipid]
                                        }
                                    });
                                }

                            }
                        }
                    } else {
                    }
                }
            } else if (message.type === 2 && !phoneNumber) {
                const allindex = allContacs.findIndex((value: any) => parseInt(value.team_id) === parseInt(message?.chatId));
                const teamindex = teamContacs.findIndex((value: any) => parseInt(value.team_id) === parseInt(message?.chatId));
                const allContactsDetails = allContacts[allindex];
                const teamid = allContactsDetails?.team_id;
                if (teamid && allindex > -1 && teamindex > -1) {
                    allContacs[allindex].team_members_favourite = message?.team_members_favourite;
                    teamContacs[teamindex].team_members_favourite = message?.team_members_favourite;
                    teamContacsnew["con" + teamid].team_members_favourite = message?.team_members_favourite;

                    store.dispatch({
                        type: Types.UPDATE_ALL_CONTACTS,
                        payload: {
                            teamContacsnew: teamContacsnew,
                            teamContacs: teamContacs,
                            workContacts: workContacts,
                            workContactsnew: workContactsnew,
                            allContacs: allContacs
                        }
                    });

                    if (chatWindowReducer?.chatWindowDetails?.team_id === teamid) {
                        let data: any = chatWindowReducer?.chatWindowDetails;
                        data.team_members_favourite = message?.team_members_favourite;
                        store.dispatch({
                            type: Types.SET_CONTACT_WINDOW,
                            payload: {
                                chatWindowDetails: data
                            }
                        });



                    }
                    if (contactWindowDetails?.team_id === teamid && isContactWindow) openContactWindowRedux(true, teamContacsnew["con" + teamid], false);
                }
            }
        }
    } catch (e) {
        console.error("Error in Recent Chat Setting", e);
    }
}

export const updateSettingStatus = (type: number, chatId: string, settings: any) => {
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    try {
        if (type === 1) {
            recentChatList[chatId].settings = settings;
        } else {
            recentChatList["con" + chatId].settings = settings;
        }
        store.dispatch({
            type: actionTypes.RECENT_MESSAGE_LIST,
            payload: {
                recentChatList: recentChatList,
                recentLoading: true
            }
        });
    } catch (e) {
        console.error("Error in Setting status", e);
    }
};
export const presenceUpdateStatus = (userStatus: any) => {

    let { userdetails }: loginReducerState = store.getState().loginReducer;
    let contactObject: any = store.getState().contactReducer;
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    let chatDetails: any = chatWindowReducer?.chatWindowDetails;
    try {
        let workContact = contactObject?.workContactsnew;
        //let workContacts = contactObject?.workContacts;
        let sip: string = Object.keys(userStatus)[0];
        if (userdetails?.sip_login_id === sip) {
            userdetails.user_status = userStatus[sip]?.connectionStatus === 0 ? "Invisible" : "Available";
        } else {
            if (userStatus[sip]?.connectionStatus === 0) {
                if (_.isUndefined(workContact?.[sip]) === false) {
                    let sts = userStatus[sip]?.connectionStatus === 0 ? "Invisible" : "Available"
                    workContact[sip].user_status = "Invisible";
                    if (workContact[sip].user_status !== sts) {
                        store.dispatch({
                            type: Types.WORK_CONTACT_GET,
                            payload: {
                                workContactsnew: workContact
                            }
                        });
                    }
                }
                if (chatDetails?.sip_login_id?.toString() === sip) {
                    chatDetails["user_status"] = "Invisible";
                }
            } else {
                if (_.isUndefined(workContact?.[sip]) === false) {
                    workContact[sip].user_status = "Available";
                    let sts = userStatus[sip]?.connectionStatus === 0 ? "Invisible" : "Available"
                    if (workContact[sip].user_status !== sts) {
                        store.dispatch({
                            type: Types.WORK_CONTACT_GET,
                            payload: {
                                workContactsnew: workContact
                            }
                        });
                    }
                }
                if (chatDetails?.sip_login_id?.toString() === sip) {
                    chatDetails["user_status"] = "Available";
                }
            }

        }
    } catch (e) {
        console.error("Error in Presence Status", e);
    }
};
export const checkpresenceUpdateStatus = (data: any) => {
    let { userdetails }: loginReducerState = store.getState().loginReducer;
    let contactObject: any = store.getState().contactReducer;
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    let chatDetails: any = chatWindowReducer?.chatWindowDetails;
    const service = new SocketChatService(userInfo().fromID, userInfo().domainId);
    try {
        let workContact = contactObject?.workContactsnew;

        Array.isArray(data) && data?.length > 0 && data.map((value: any) => {
            let sip: string = Object.keys(value)[0];
            if (userdetails?.sip_login_id === sip && value[sip]?.deviceType ==="Web") {
                userdetails.user_status = value[sip]?.connectionStatus === 0 ? "Invisible" : "Available";
            }
            if(userdetails?.sip_login_id === sip && value[sip]?.connectionStatus === 0 && (value[sip]?.deviceType === "IOS" || value[sip]?.deviceType === "Android" )){
                let datares: any = { status: "1" }
                service?.socketConnection.checkPresenceStatus(datares);
 
            }
            if (userdetails?.sip_login_id !== sip && (value[sip]?.connectionStatus === "0" || value[sip]?.connectionStatus === 0)) {
                if (_.isUndefined(workContact?.[sip]) === false) {
                    workContact[sip].user_status = "Invisible";
                    if (chatDetails?.sip_login_id?.toString() === sip) {
                        chatDetails["user_status"] = "Invisible";
                    }
                }
            } else {
                if (userdetails?.sip_login_id !== sip && (value[sip]?.connectionStatus === "1" || value[sip]?.connectionStatus === 1)) {
                    if (_.isUndefined(workContact?.[sip]) === false) {
                        workContact[sip].user_status = "Available";
                        if (chatDetails?.sip_login_id?.toString() === sip) {
                            chatDetails["user_status"] = "Available";
                        }
                    }

                }

            }
        });
        store.dispatch({
            type: Types.WORK_CONTACT_GET,
            payload: {
                workContactsnew: workContact
            }
        });

    } catch (e) {
        console.error("Error in Presence Status", e);
    }
};
export const chatTyping = (message: any) => {
    let contactRed = store.getState().contactReducer;
    let typingReducer = store.getState().typingReducerState;
    try {
        let { workContactsnew, teamContacsnew }: any = contactRed;
        const userDetailsnew = userInfo();
        const currUser = parseInt(userDetailsnew.fromID);
        const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
        if (recentID && parseInt(message.from) !== currUser) {
            if (message && message?.chatId && message?.chatId?.toString().indexOf("chat") > -1 && recentID !== userDetailsnew?.fromID) {
                let typingUser: any = workContactsnew[recentID];
                const typingList = typingReducer.typingList;
                if (_.isUndefined(typingList?.[typingUser?.sip_login_id]) === true && typingUser) {
                    typingList[recentID] = typingUser;
                    typingList[recentID].msgType = 1;
                    typingList[recentID].chatId = recentID;
                }
                store.dispatch({
                    type: actionTypes.TYPING_STATUS,
                    payload: {
                        msgType: message?.chatId?.toString().indexOf("chat") > -1 ? 1 : message?.chatId ? 2 : 0,
                        typingList: typingList
                    }
                });
            } else if (message && message?.chatId && message?.chatId?.toString().indexOf("chat") === -1) {
                let typingUser: any = teamContacsnew?.["con" + message?.chatId];
                // console.log("typing User New ---->", typingUser?.participants);
                const typingList = typingReducer.typingList;

                if (typingUser?.team_id && message?.chatId) {
                    let typingUserNew: any = workContactsnew[recentID];
                    typingList["con" + message?.chatId] = typingUser;
                    typingList["con" + message?.chatId].msgType = 2;
                    typingList["con" + message?.chatId].chatId = message?.chatId;
                    typingList["con" + message?.chatId].participants = {};
                    typingList["con" + message?.chatId].participants[recentID] = typingUserNew;
                    store.dispatch({
                        type: actionTypes.TYPING_STATUS,
                        payload: {
                            msgType: message?.chatId?.toString().indexOf("chat") > -1 ? 1 : message?.chatId ? 2 : 0,
                            typingList: typingList
                        }
                    });
                }
            }
        }
    } catch (e) {
        console.error("Error in Chat Typing", e);
    }
};

export const aiAssist=(message:any)=>{
    const {isCaptureAi,isAiAssist}:any=store.getState().chatReducer;
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    try{
        if(message.hasOwnProperty("buffer") && message.buffer && isCaptureAi){                   
            let cleanedBase64 = message.buffer.replace(/^b'/, '').replace(/'$/, '');
            cleanedBase64 = cleanedBase64.replace(/[^A-Za-z0-9+/=]/g, '');
          //   let substr:any=cleanedBase64.substring(1);
          //   console.log("substrsubstr>>",substr);
            const binaryString = atob(cleanedBase64);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
      
            const audioBlob = new Blob([bytes], { type: 'audio/wav' });
            const audioUrl = URL.createObjectURL(audioBlob);
            let audio:any=document.createElement("audio");
            audio.src=audioUrl;
            audio.play();
            const onAudioEnded = () => {
              audio.removeEventListener('ended', onAudioEnded);
              URL.revokeObjectURL(audioUrl);
            };
            audio.addEventListener('ended', onAudioEnded);
      }
          if(message.hasOwnProperty("finalText")){setAiAssist(isAiAssist,isCaptureAi, message.finalText, {suggestions:[],prompt:"",error:""});}
          if(message.hasOwnProperty("output") && message.output !== "null" && message.output !== null &&  !_.isEmpty(message.output)){
             let parsed:any= JSON.parse(message?.output);
             if(parsed.error ===0 && isCaptureAi){
              setAiAssist(isAiAssist,isCaptureAi,parsed.prompt,{suggestions:[],prompt:"",error:""})
              setTimeout(()=>{
              if(isCaptureAi){handleStartRecording();}
              setAiAssist(isAiAssist,isCaptureAi,'Listening...',{suggestions:[],prompt:"",error:""})
          },5000)
          return;}
              if(parsed.suggestions?.length > 1 || (parsed.suggestions?.length > 0 && parsed.intent ==="meeting_available")){
      setAiAssist(isAiAssist,isCaptureAi, parsed.prompt, {"suggestions" : parsed.suggestions,"prompt" : "","error":""});
      store.dispatch({
          type:Types.SET_ARR_BUFFER,
          payload:{
            aiSessionId:"",
            arrayBuffer:[],
            intent:parsed.intent,
            aiAssistMessage:parsed.intent ==="send_a_Message" ?  parsed.message : ""
          }
        })
      }
      else if (parsed.suggestions?.length === 0 && parsed.intent === "meeting_available") {
        setAiAssist(isAiAssist, isCaptureAi, parsed.prompt, {
          "suggestions": [],
          "prompt": parsed.prompt, 
          "error": ""
        });
        
      }
       if(parsed.suggestions?.length === 1 &&  isCaptureAi &&  parsed.error === 1){
          if(parsed.intent ==="make_a_Call"){setAiAssist(isAiAssist,isCaptureAi,parsed.prompt, {suggestions:[],prompt:"",error:""});
          setTimeout(()=>{
              store.dispatch({
                  type:Types.SET_ARR_BUFFER,
                  payload:{
                    aiSessionId:"",
                    arrayBuffer:[],
                    intent:parsed.intent,
                    aiAssistMessage:""
                  }
                })
              initiateCall(parsed.suggestions[0].ext,"audio")
              setAiAssist(false,false,"", {suggestions:[],prompt:"",error:""});
          },3000)
      }
            else if(parsed.intent ==="send_a_Message"){
              let { userdetails }: loginReducerState = store.getState().loginReducer;
              setAiAssist(isAiAssist,isCaptureAi,parsed.prompt, {suggestions:[],prompt:"",error:""});
              let   contactDetail:any = _.find(companyContact, function (o) {
                  return (o.ext === parsed.suggestions[0].ext)
                });
              store.dispatch({
                  type:Types.SET_CONTACT_WINDOW,
                  payload:{chatWindowDetails:contactDetail}
              })
              const socketservice = new SocketChatService(userdetails?.sip_login_id, userdetails?.domain_id);
              const userDetails = userInfo();
              const id:any=generateChatID(userDetails.fromID, parsed.suggestions[0].sipid)
              store.dispatch({
                  type:Types.SET_ARR_BUFFER,
                  payload:{
                      aiSessionId:"",
                      arrayBuffer:[],
                      intent:parsed.intent,
                      aiAssistMessage:parsed.message
                  }
              })
              setTimeout(()=>{
                  setAiAssist(false,false,"", {suggestions:[],prompt:"",error:""});
                  socketservice.openChatWindow(contactDetail,"",{chatId:id});
              },3000) 
          }
          else{
            console.log("else part called");
          }
            
      }
      }
    }
            catch(err:any){
            console.log("error",err);
            }
}

export const chatTypingStop = (message: any) => {
    let typingReducer = store.getState().typingReducerState;
    let contactRed = store.getState().contactReducer;
    let { workContactsnew }: any = contactRed;
    const userDetailsnew = userInfo();
    try {
        const currUser = parseInt(userDetailsnew.fromID);
        const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
        const typingList = typingReducer.typingList;
        let typingUser: any = workContactsnew[recentID];

        if (workContactsnew[recentID]) {
            if (message?.chatId?.toString().indexOf("chat") > -1 &&
                _.isUndefined(typingList?.[typingUser?.sip_login_id]) === false) {
                delete typingList[recentID];
            } else if (message?.chatId?.toString().indexOf("chat") === -1) {
                if (typingList["con" + message.chatId]?.participants) {
                    delete typingList["con" + message.chatId];
                }
            }
        }

        store.dispatch({
            type: actionTypes.TYPING_STATUS,
            payload: {
                typingList: typingList
            }
        });
    } catch (e) {
        console.error("Error in Chat Typing Stop", e);
    }
};

export const editMessageChat = (socket: any, message: any) => {
    let { messageList }: any = store.getState().chatSocketReducerState;
    let { savedListDetails }: rightSidePanelDetails = store.getState().chatRightSidePanelReducer;
    let { recentChatList, savedChatList }: any = store.getState().chatSocketRecentReducerState;
    const userDetailsnew = userInfo();
    const currUser = parseInt(userDetailsnew.fromID);
    const recentID = parseInt(message?.from) !== currUser ? message?.from : parseInt(message?.to) !== currUser ? message?.to : "";

    try {
        const newMessageList = messageList.map((value: any) => {
            if (value.id === message.id) {
                let newMessage = { ...value };
                newMessage.message.body = message.message?.body;
                newMessage.message["isEdit"] = message.message?.isEdit;
                return newMessage;
            } else {
                return value;
            }
        });
        if (Array.isArray(savedListDetails) && savedListDetails.length > 0) {
            const saveEditMessage = savedListDetails.map((value: any) => {
                if (value.id === message.id) {
                    let newMessage = { ...value };
                    newMessage.message.body = message.message?.body;

                    return newMessage;
                } else {
                    return value;
                }
            });
            store.dispatch({
                type: Types.GET_SAVED_LIST,
                payload: {
                    isSavedList: true,
                    savedListDetails: saveEditMessage
                }
            });
        }
        if (Array.isArray(savedChatList) && savedChatList.length > 0) {
            const leftSideSaveEditMessage = savedChatList.map((value: any) => {
                if (value.id === message.id) {
                    let newMessage = { ...value };
                    newMessage.message.body = message.message?.body;

                    return newMessage;
                } else {
                    return value;
                }
            });
            store.dispatch({
                type: Types.GET_SAVED_LIST,
                payload: {
                    isSavedList: true,
                    savedListDetails: leftSideSaveEditMessage
                }
            });
        }
        if (recentID) {
            if (recentChatList[recentID]?.lastmessage?.id === message?.id) {
                if (recentChatList?.[recentID]) {
                    recentChatList[recentID].lastmsgText = message.message?.body;
                    recentChatList[recentID].createdAt = message.createdAt;
                    recentChatList[recentID].updatedAt = message.updatedAt;
                    recentChatList[recentID].lastmessage = message;
                }

                store.dispatch({
                    type: actionTypes.RECENT_MESSAGE_LIST,
                    payload: {
                        recentChatList: recentChatList,
                        recentLoading: true
                    }
                });
            }

        }

        store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: newMessageList,
                messageLoading: false
            }
        });
    } catch (e) {
        console.error("Error in Edit message", e);
    }
};

export const openChatWindowRedux = (data?: any) => {
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;

    store.dispatch({
        type: Types.OPEN_CHAT_WINDOW,
        payload: {
            isChatWindow: chatWindowReducer.isChatWindow,
            chatWindowDetails: data,
            isMySpace: chatWindowReducer.isMySpace
        }
    });
};

export const openContactWindowRedux = (contactWindow?: any, data?: any, mySpace?: any) => {
    store.dispatch({
        type: Types.OPEN_CONTACT_WINDOW,
        payload: {
            isContactWindow: contactWindow,
            contactWindowDetails: data,
            isMySpace: mySpace
        }
    });
};

export const setTeamContactNew = (data: any, loading: any) => {
    store.dispatch({
        type: Types.TEAM_CONTACT_NEW,
        payload: {
            teamContacsnew: data,
            isTeamContactLoading: loading
        }
    });
};

export const setAllContact = (data: any) => {
    store.dispatch({
        type: Types.ALL_CONTACT,
        payload: {
            allContacs: data
        }
    });
};

export const savedMessageList = (socket: any, savedChat: any) => {
    let { messageList }: any = store.getState().chatSocketReducerState;
    let { savedListDetails, linkListDetails, fileListDetails }: rightSidePanelDetails = store.getState().chatRightSidePanelReducer;
    let { userdetails }: LoginState = store.getState().loginReducer;
    let { contactSavedChatList, contactLinkList, contactFileList }: contactwindowDetails = store.getState().contactWindowReducer;
    let { isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;

    try {

        const savedMessageList = messageList.map((value: any) => {
            if (value.id === savedChat.id) {
                let newMessage = { ...value };
                newMessage.message['isSave'] = savedChat.message?.isSave;
                return newMessage;
            } else {
                return value;
            }
        });
        if (window.location.pathname === "/chats") {

            if (savedChat.message?.isSave['s' + userdetails.sip_login_id] === 1) {

                let saveRightSide = savedChatListFraming(savedChat);
                savedListDetails.unshift(saveRightSide);


            }
            else {
                if (Array.isArray(savedListDetails) && savedListDetails.length > 0) {
                    let particularIndex = savedListDetails.findIndex((data: any) => data.id === savedChat.id);
                    // console.log("particularIndex-----", particularIndex);
                    particularIndex !== -1 && savedListDetails.splice(particularIndex, 1);
                }
            }
            if (Array.isArray(linkListDetails) && linkListDetails.length > 0) {
                let linkIndex = linkListDetails?.findIndex((data: any) => data?.id === savedChat?.id);
                if (linkIndex > -1) {
                    linkListDetails[linkIndex].message['isSave'] = savedChat?.message?.isSave;
                }
            }
            if (Array.isArray(fileListDetails) && fileListDetails.length > 0) {
                let linkIndex = fileListDetails?.findIndex((data: any) => data?.id === savedChat?.id);
                if (linkIndex > -1) {
                    fileListDetails[linkIndex].message['isSave'] = savedChat?.message?.isSave;
                }
            }


            if (isMySpace && Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0) {

                if (Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0 &&
                    savedChat.message?.isSave['s' + userdetails.sip_login_id] !== 1) {
                    let Index = contactSavedChatList?.findIndex((data: any) => data?.id === savedChat?.id);
                    if (Index > -1) {
                        Index !== -1 && contactSavedChatList.splice(Index, 1);
                    }
                }
                store.dispatch({
                    type: Types.CONTACT_SAVED_LIST,
                    payload: {
                        contactSavedChatList: contactSavedChatList
                    }
                });
            }
            if (isMySpace && Array.isArray(contactLinkList) && contactLinkList.length > 0) {
                let savedMessageList = contactLinkList.map((value: any) => {
                    if (value.id === savedChat.id) {
                        let newMessage = { ...value };
                        newMessage.message['isSave'] = savedChat.message?.isSave;
                        return newMessage;
                    } else {
                        return value;
                    }
                });
                store.dispatch({
                    type: Types.CONTACT_LINK_LIST,
                    payload: {
                        contactLinkList: savedMessageList
                    }
                });
            }
        }

        if (window.location.pathname === "/contacts") {
            if (Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0 && savedChat.message?.isSave['s' + userdetails.sip_login_id] === 1) {

                let saveRightSide = savedChatListFraming(savedChat);
                contactSavedChatList.unshift(saveRightSide);


            }
            else {
                if (Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0) {
                    let particularIndex = contactSavedChatList.findIndex((data: any) => data.id === savedChat.id);
                    // console.log("particularIndex-----", particularIndex);
                    particularIndex !== -1 && contactSavedChatList.splice(particularIndex, 1);
                }
                if (Array.isArray(contactLinkList) && contactLinkList.length > 0) {
                    let linkIndex = contactLinkList?.findIndex((data: any) => data?.id === savedChat?.id);
                    if (linkIndex > -1) {
                        contactLinkList[linkIndex].message['isSave'] = savedChat?.message?.isSave;
                    }
                }
            }
            store.dispatch({
                type: Types.CONTACT_SAVED_LIST,
                payload: {
                    contactSavedChatList: contactSavedChatList
                }
            });
            store.dispatch({
                type: Types.CONTACT_LINK_LIST,
                payload: {
                    contactLinkList: contactLinkList
                }
            });
        }


        store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: savedMessageList,
                messageLoading: false
            }
        });
        const contactMsgFileList = contactFileList.map((value: any) => {
            if (value.id === savedChat.id) {
                let newMessage = { ...value };
                newMessage.message['isSave'] = savedChat.message?.isSave;
                return newMessage;
            } else {
                return value;
            }
        });
        store.dispatch({
            type: Types.CONTACT_FILES_LIST,
            payload: {
                isContactFile: true,
                contactFileList: contactMsgFileList
            }
        });
        // store.dispatch({
        //     type: Types.GET_SAVED_LIST,
        //     payload: {
        //         isSavedList: true,
        //         savedListDetails: savedListDetails
        //     }
        // });
        store.dispatch({
            type: Types.GET_LINK_LIST,
            payload: {
                isLink: true,
                linkListDetails: linkListDetails
            }
        });
    } catch (e) {
        console.error("Error in Save Message List", e);
    }

}

export const likeMessage = (socket: any, likedMessage: any) => {
    try {
        let { messageList }: any = store.getState().chatSocketReducerState;
        let { savedListDetails, linkListDetails, fileListDetails }: rightSidePanelDetails = store.getState().chatRightSidePanelReducer;
        let { contactSavedChatList, contactLinkList, contactFileList }: contactwindowDetails = store.getState().contactWindowReducer;
        let { isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;
        const userDetailsnew = userInfo();
        //let {chatBellNotification}: BellIconNotification = store.getState().bellNotification;

        if (likedMessage?.likedStatus) {
            let likeUser = (Object.keys(likedMessage.likedStatus)[0]).slice(1) || "";
            if (likeUser !== userDetailsnew.fromID && likedMessage.likedStatus["s" + likeUser] === 1) {
                let contactObject: any = store.getState().contactReducer;
                var currentTimestamp = moment().valueOf();
                const fromCaller = contactObject.workContactsnew[parseInt(likeUser)];
                const teamCaller = contactObject.teamContacsnew["con" + (likedMessage?.chatId)];
                const user = likedMessage?.type === 2 ? teamCaller?.team_name : fromCaller?.caller_id;

                let inputOptions = {
                    userName: user,
                    message: likedMessage,
                    id: fromCaller,
                    isLiked: true

                };
                if (fromCaller?.is_muted && fromCaller?.mute_timestamp) {
                    if (parseInt(fromCaller?.mute_timestamp) < currentTimestamp) {
                        chatNotificationFlow(inputOptions, '');
                    }

                } else if (!fromCaller?.is_muted) {
                    chatNotificationFlow(inputOptions, '');

                }
            }
            tempPushNotification(likedMessage);
        }

        const likeMessageList = messageList.map((value: any) => {
            if (value.id === likedMessage.id) {
                let newMessage = { ...value };
                newMessage.message['liked'] = likedMessage.message?.liked;
                return newMessage;
            } else {
                return value;
            }
        });
        if (window.location.pathname === "/chats") {
            if (Array.isArray(savedListDetails) && savedListDetails.length > 0) {

                const saveMessaeLikeList = savedListDetails.map((data: any) => {
                    if (data.id === likedMessage.id) {
                        let newMessage = { ...data };
                        newMessage.message['liked'] = likedMessage.message?.liked;
                        return newMessage;
                    } else {
                        return data;
                    }
                });
                store.dispatch({
                    type: Types.GET_SAVED_LIST,
                    payload: {
                        isSavedList: true,
                        savedListDetails: saveMessaeLikeList
                    }
                });

            }
            if (isMySpace && Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0) {

                const contactSavedChat = contactSavedChatList.map((data: any) => {
                    if (data.id === likedMessage.id) {
                        let newMessage = { ...data };
                        newMessage.message['liked'] = likedMessage.message?.liked;
                        return newMessage;
                    } else {
                        return data;
                    }
                });
                store.dispatch({
                    type: Types.CONTACT_SAVED_LIST,
                    payload: {
                        contactSavedChatList: contactSavedChat
                    }
                });
            }
            if (Array.isArray(fileListDetails) && fileListDetails.length > 0) {
                let linkIndex = fileListDetails?.findIndex((data: any) => data?.id === likedMessage?.id);
                if (linkIndex > -1) {
                    fileListDetails[linkIndex].message['liked'] = likedMessage.message?.liked;
                }
            }
            if (isMySpace && Array.isArray(contactLinkList) && contactLinkList.length > 0) {

                const contactLikeChat = contactLinkList.map((data: any) => {
                    if (data.id === likedMessage.id) {
                        let newMessage = { ...data };
                        newMessage.message['liked'] = likedMessage.message?.liked;
                        return newMessage;
                    } else {
                        return data;
                    }
                });
                store.dispatch({
                    type: Types.CONTACT_LINK_LIST,
                    payload: {
                        contactLinkList: contactLikeChat
                    }
                });
            }
        }
        if ((isMySpace || window.location.pathname === "/contacts") && Array.isArray(contactFileList) && contactFileList.length > 0) {
            let linkIndex = contactFileList?.findIndex((data: any) => data?.id === likedMessage?.id);
            if (linkIndex > -1) {
                contactFileList[linkIndex].message['liked'] = likedMessage.message?.liked;
            }
        }
        if (window.location.pathname === "/contacts") {
            if (Array.isArray(contactSavedChatList) && contactSavedChatList.length > 0) {

                const contactSavedChat = contactSavedChatList.map((data: any) => {
                    if (data.id === likedMessage.id) {
                        let newMessage = { ...data };
                        newMessage.message['liked'] = likedMessage.message?.liked;
                        return newMessage;
                    } else {
                        return data;
                    }
                });
                store.dispatch({
                    type: Types.CONTACT_SAVED_LIST,
                    payload: {
                        contactSavedChatList: contactSavedChat
                    }
                });
            }
            if (Array.isArray(contactLinkList) && contactLinkList.length > 0) {

                const contactLikeChat = contactLinkList.map((data: any) => {
                    if (data.id === likedMessage.id) {
                        let newMessage = { ...data };
                        newMessage.message['liked'] = likedMessage.message?.liked;
                        return newMessage;
                    } else {
                        return data;
                    }
                });
                store.dispatch({
                    type: Types.CONTACT_LINK_LIST,
                    payload: {
                        contactLinkList: contactLikeChat
                    }
                });
            }
        }

        if (Array.isArray(linkListDetails) && linkListDetails.length > 0) {
            const linklistMessage = linkListDetails.map((data: any, index: any) => {

                if (data.id === likedMessage.id) {
                    let newMessage = { ...data };
                    newMessage.message['liked'] = likedMessage.message?.liked;
                    return newMessage;
                } else {
                    return data;
                }
            });


            store.dispatch({
                type: Types.GET_LINK_LIST,
                payload: {
                    isLink: true,
                    linkListDetails: linklistMessage
                }
            });
        }
        store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: likeMessageList,
                messageLoading: false
            }
        });
    } catch (e) {
        console.error("Error in Like message", e);
    }
}

export const fileList = (socket: any, fileListData: any) => {
    try {
        if (_.isArray(fileListData)) {
            let displayFileList = [];
            displayFileList = _.filter(fileListData, ((item: any) => {
                return (_.isUndefined(item.message?.isDelete)) ? item : !item.message.isDelete;
            }));
            if (_.isArray(displayFileList)) {
                if (window.location.pathname === "/contacts") {
                    store.dispatch({
                        type: Types.CONTACT_FILES_LIST,
                        payload: {
                            isContactFile: true,
                            contactFileList: displayFileList
                        }
                    })
                } else {
                    store.dispatch({
                        type: Types.GET_FILES_LIST,
                        payload: {
                            isfile: true,
                            fileListDetails: displayFileList
                        }
                    });
                }
            }
        }
    } catch (e) {
        console.error("Error in File List", e);
    }
}

export const getSavedList = (socket: any, savedList: any) => {
    let { contactSavedLength, contactSavedChatList }: contactwindowDetails
        = store.getState().contactWindowReducer;
    let { savedListDetails }: rightSidePanelDetails = store.getState().chatRightSidePanelReducer || [];
    let saveChatListLength = savedListDetails.length || 0;
    try {
        if (Array.isArray(savedList) && savedList.length > 0) {

            let displaySavedList: any = [];
            displaySavedList = _.filter(savedList, ((item: any) => {

                return _.isUndefined(item.message.isDelete) ? item : !item?.message?.isDelete;
            }));

            if (window.location.pathname === "/chats") {

                let listSavedMessage = displaySavedList.map((data: any, index: any) => {

                    return savedChatListFraming(data);
                });
                if (saveChatListLength !== 0) {
                    listSavedMessage = listSavedMessage;
                }
                store.dispatch({
                    type: Types.GET_SAVED_LIST,
                    payload: {
                        isSavedList: true,
                        savedListDetails: listSavedMessage
                    }
                });
            }
            else if (window.location.pathname === "/contacts") {

                savedChatContactFraming(displaySavedList);
            }

        }

        else {
            store.dispatch({
                type: Types.GET_SAVED_LIST,
                payload: {
                    isSavedList: true,
                    savedListDetails: saveChatListLength === 0 ? [] : savedListDetails
                }
            });
            store.dispatch({
                type: Types.CONTACT_SAVED_LIST,
                payload: {
                    contactSavedChatList: contactSavedLength === 0 ? [] : contactSavedChatList
                }
            });
        }
    } catch (e) {
        console.error("Error in Saved List", e);
    }
}

export const chatLinkList = (socket: any, linkListData: any) => {
    let { linkListDetails }: rightSidePanelDetails = store.getState().chatRightSidePanelReducer || [];
    try {
        if (Array.isArray(linkListData) && linkListData.length > 0) {
            let displayFileList: any = [];
            displayFileList = _.filter(linkListData, ((item: any) => {

                return _.isUndefined(item.message.isDelete) ? item : !item?.message?.isDelete;
            }));

            let linklistMessage = displayFileList.map((data: any, index: any) => {
                return savedChatListFraming(data);
            });

            if (Array.isArray(linkListDetails) && linkListDetails.length !== 0) {
                linklistMessage = linkListDetails.concat(linklistMessage);
            }
            store.dispatch({
                type: Types.GET_LINK_LIST,
                payload: {
                    isLink: true,
                    linkListDetails: linklistMessage
                }
            });
        }

        else {
            store.dispatch({
                type: Types.GET_LINK_LIST,
                payload: {
                    isLink: true,
                    linkListDetails: linkListDetails.length === 0 ? [] : linkListDetails
                }
            });
        }
        if (window.location.pathname === "/contacts") {
            linkListContactFraming(linkListData);
        }
    } catch (e) {
        console.error("Error in Link List", e);
    }
}

export const deleteMessageChat = (message: any) => {
    let { messageList }: any = store.getState().chatSocketReducerState;
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    const userDetailsnew = userInfo();
    try {
        const currUser = parseInt(userDetailsnew.fromID);
        const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";

        const newMessageList = messageList.map((value: any) => {
            if (value.id === message.id) {
                let newMessage = { ...value };
                newMessage.message.body = message.message?.body;
                newMessage.message.messageType = "TEXT";
                newMessage.message.isDelete = message.message.isDelete;
                return newMessage;
            } else {
                return value;
            }
        });
        store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: newMessageList,
                messageLoading: false
            }
        });
        let recent: any = message?.type === 2 ? recentChatList["con" + message?.chatId] : recentChatList[parseInt(recentID)];
        if (recent && recent?.lastmessage?.id === message?.id) {
            if (recent.lastmessage?.message) {
                recent.lastmsgText = "Deleted this message"
                recent.lastmessage.message.isDelete = message.message.isDelete;
                store.dispatch({
                    type: actionTypes.RECENT_MESSAGE_LIST,
                    payload: {
                        recentChatList: recentChatList,
                        recentLoading: true
                    }
                });
            }

        }
    } catch (e) {
        console.error("Error in Recent Chat List", e);

    }

}

export const savedChatMySpaceListen = (socket: any, allSaveList: any) => {
    savedChatContactFraming(allSaveList);
}

export const userProfileUpdated = (socket: any, data: any) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let contactRed = store.getState().contactReducer;
    let { workContacts, allContacs, workContactsnew, allContactsNew, teamContacsnew, teamContacs }: any = contactRed;
    try {
        if (userdetails.sip_login_id !== data.sipid) {
            let wIndex = workContacts.findIndex((value: any) => value.sip_login_id.toString() === data.sipid.toString());
            let allContacsIndex = allContacs.findIndex((value: any) =>
                value.sip_login_id && value.sip_login_id.toString() === data.sipid.toString());
            if (wIndex > -1 && allContacsIndex > -1 && workContactsnew?.[data.sipid]) {
                workContacts[wIndex].ImageURL = data.files.geturl;
                allContacs[allContacsIndex].ImageURL = data.files.geturl;
                workContactsnew[data.sipid].ImageURL = data.files.geturl;

                store.dispatch({
                    type: Types.UPDATE_ALL_CONTACTS,
                    payload: {
                        allContactsNew: allContactsNew,
                        teamContacsnew: teamContacsnew,
                        teamContacs: teamContacs,
                        workContactsnew: workContactsnew,
                        allContacs: allContacs,
                        workContacts: workContacts
                    }
                });
            }

        }
    } catch (e) {
        console.error("Error in Profile Updated", e);
    }
}


export const getMyspaceFileslist = (filesList: any) => {

    store.dispatch({
        type: Types.CONTACT_FILES_LIST,
        payload: {
            isContactFile: true,
            contactFileList: filesList
        }
    })

}


export const newMessageGroupSuccess = (message: any, text: any) => {
    try {
        if (message.data) {
            let contactRed = store.getState().contactReducer;
            let { teamContacsnew, allContacs }: any = contactRed;

            let teamKey: any = message.data.team_id_prefix + message.data.team_id;
            allContacs.push(message.data);

            Object.assign(teamContacsnew, { [teamKey]: message.data });
            store.dispatch({
                type: Types.TEAM_CONTACT_NEW,
                payload: {
                    teamContacsnew: teamContacsnew,
                    isTeamContactLoading: true
                }
            });
            store.dispatch({
                type: Types.ALL_CONTACT,
                payload: {
                    allContacs: allContacs
                }
            });
            //  let toastInfo = message.data.admin_members.replace(" ", "");
            //toastOnlyHost(toastInfo, "Team created successfully");
        } else {
            toastInformation("Something went wrong", "failure");
        }
    } catch (e) {
        console.error("Error in Group message", e);
    }
};

export const getMyspaceLinklist = (listSavedContact: any) => {
    linkListContactFraming(listSavedContact);
};

export const savedChatContactFraming = (list: any) => {
    let { contactSavedLength, contactSavedChatList }: contactwindowDetails = store.getState().contactWindowReducer;

    let listSavedContact = list.map((data: any, index: any) => {
        return savedChatListFraming(data);
    });
    if (contactSavedLength > 0) {
        listSavedContact = contactSavedChatList.concat(listSavedContact);
    }
    store.dispatch({
        type: Types.CONTACT_SAVED_LIST,
        payload: {
            contactSavedChatList: listSavedContact
        }
    });
};
export const linkListContactFraming = (linkList: any) => {
    let { contactLinkLength, contactLinkList }: contactwindowDetails = store.getState().contactWindowReducer;
    try {
        if (linkList.length > 0) {
            let displayFileList: any = [];
            displayFileList = _.filter(linkList, (item: any) => {
                return _.isUndefined(item.message.isDelete) ? item : !item?.message?.isDelete;
            });

            let listSavedContact = displayFileList.map((data: any, index: any) => {
                return savedChatListFraming(data);
            });
            if (contactLinkLength > 0) {
                listSavedContact = contactLinkList.concat(listSavedContact);
            }
            store.dispatch({
                type: Types.CONTACT_LINK_LIST,
                payload: {
                    contactLinkList: listSavedContact
                }
            });
        } else {
            store.dispatch({
                type: Types.CONTACT_LINK_LIST,
                payload: {
                    contactLinkList: contactLinkLength > 0 ? contactLinkList : []
                }
            });
        }
    } catch (e) {
        console.error("Error in Contact framing", e);
    }
};


export const newVoicemail = (data: any) => {
    let { logsInput } = store.getState().callReducer || {};
    getAllCounts();
    let { leftSideWindow } = store.getState().updatedCallList;
    leftSideWindow === 'voiceMail' && getVoiceMailLogs(logsInput.offset, logsInput.search);

}

export const newRecordedcall = (data: any) => {
    let { logsInput } = store.getState().callReducer || {};
    getAllCounts();
    let { leftSideWindow } = store.getState().updatedCallList;
    leftSideWindow === 'recordList' && getRecordingLogs(logsInput.offset, logsInput.search);
}

export const activeUserDevicesList = (deviceList: any) => {

    if (deviceList) {

        store.dispatch({
            type: actionTypes.DEVICE_LIST,
            payload: {
                aciveDevicesList: deviceList
            }
        });
    }
}

export const updateActiveDevicesList = (newDevice: any) => {
    // {'9542': [ 'Web', 'Android' ]}
    // {'9542':[]}

    // let {aciveDevicesList}: deviceListModel = store.getState().deviceListReducer;

    // Object.assign(aciveDevicesList, newDevice);

    // store.dispatch({
    //     type: actionTypes.DEVICE_LIST,
    //     payload: {
    //         aciveDevicesList:aciveDevicesList
    //     }
    // });
}

export const getRecording=()=>{
    let recdata: any ={};
    recdata.offset = 0;
    recdata.limit = 10;
    recdata.search = "";
    getVideoRecordingLists(recdata);
}

export const getCreateMeeting = (meetingList: any) => {
    let { getListInput } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;

        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        updateMeetingTotalBatch();
    } catch (e) {
        console.error("Error in handleCreateMeeting", e);
    }
}

export const getInstantMeeting = (meetingList: any) => {
    console.log("getInstantMeeting >>>", meetingList)
    let host: any = store.getState().loginReducer.userdetails || [];
    let meetingReducer: any = store.getState().meetingReducer;
    // console.log(meetingReducer,"meetingRedurer===");
    let { getListInput } = store.getState().meetingReducer;

    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;

        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        // if(host.sip_login_id !== meetingList.hostDetails.sipId){
        //     console.log("participants notification=====");

        //     const inputOptions = {
        //       userName: meetingList.meetingName,
        //       url:meetingList.inviteUrl,
        //       message: ' Meeting Started '+ meetingList.hostDetails.name +'(Host) \n'
        //   };
        //    showBrowserNotification(inputOptions,'meeting');
        //   }
        // callmeetingnotification(4);
    } catch (e) {
        console.error("Error in getInstantMeeting", e);
    }
}
export const RingingStopNotification = (message: any) => {
    closeVideoRinging();
}

export const accpectVideoCallDirect = (message:any) => {
    videoCallReqNotfy("accept");
    let replaced_url: any = message.meetingDetails.inviteUrl?.includes("stagemeet") ?
        `${message.meetingDetails.inviteUrl}?type=meetnow` : `${message.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;

    // setTimeout(() => {
        window.open(replaced_url, '_blank');
    // }, 1000)
}


export const handleVideocallRequest = (message: any) => {
    console.log("handleVideocallRequest message >>>>>>>", message);

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: message,
            isVideocallRingvideo: true,
            isDirectVideocall: false
        }
    })
}

export const handleVideocallAccept = (message: any) => {
    console.log("handleVideocallAccept message >>>>>>>", message);

    currentCallEnd()
    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
            isVideoRequestSent: false,
            meetingDetails: {}
        }
    })
    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isVideocallRingvideo: false,
            isDirectVideocall: false
        }
    })

    let replaced_url: any = message.meetingDetails.inviteUrl?.includes("stagemeet") ?
        `${message.meetingDetails.inviteUrl}?type=switchtovideo` : `${message.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=switchtovideo`;

    window.open(replaced_url, '_blank');
}

export const handleVideocallCancel = (message: any) => {
    console.log("handleVideocallRequest message >>>>>>>", message);


    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
            isVideoRequestSent: false,
            meetingDetails: {}
        }
    })

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isVideocallRingvideo: false,
            isDirectVideocall: false
        }
    })
}


export const handleDirectVideocallRequest = (message: any) => {
    console.log("handleVideocallRequest message >>>>>>>", message);

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: message,
            isVideocallRingvideo: true,
            isDirectVideocall: true
        }
    })
}

export const handleDirectVideocallAccept = (message: any) => {
    console.log("handleVideocallAccept message >>>>>>>", message);

    // currentCallEnd()

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
            isVideoRequestSent: false,
            meetingDetails: {}
        }
    })

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isVideocallRingvideo: false,
            isDirectVideocall: false
        }
    })

    let replaced_url: any = message.meetingDetails.inviteUrl?.includes("stagemeet") ?
        `${message.meetingDetails.inviteUrl}?type=meetnow` : `${message.meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;

    // setTimeout(() => {
        window.open(replaced_url, '_blank');
    // }, 2000)
}

export const handleDirectVideocallCancel = (message: any) => {
    console.log("handleVideocallRequest message >>>>>>>", message);


    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_SENT,
        payload: {
            isVideoRequestSent: false,
            meetingDetails: {}
        }
    })

    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isVideocallRingvideo: false,
            isDirectVideocall: false
        }
    })
}
export const handleCallConnectedInfo = (message: any) => {
    console.log("handleVideocallRequest message >>>>>>>", message);


    store.dispatch({
        type: Types.CONNECTED_CALL_INFO,
        payloads: {
            connectedCallInfo: message
        }
    })

}




export const handleCancelMeeting = (meetingList: any) => {

    console.log("handleCancelMeeting >>>", meetingList)

    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        if (detailPage && meetingList.uuid === detailPage.uuid && currentWindowState === "meetingDetails") {
            let updatedInfo: any = detailPage;
            updatedInfo = {
                ...updatedInfo, status: "Cancelled"
            };
            storeMeetingPage(updatedInfo);
        }
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
    } catch (e) {
        console.error("Error in handleCancelMeeting ", e);
    }
}


export const meetingNotification = (meetingDetail: any) => {
    // console.log("meetingDetail --->",meetingDetail);
}

export const update=(meetingList: any)=>{
    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        if (detailPage && meetingList.uuid === detailPage.uuid && currentWindowState === "meetingDetails") {
            let updatedInfo: any = detailPage;
            updatedInfo = {
                ...updatedInfo, end_timestamp:meetingList.end_timestamp,start_timestamp:meetingList.start_timestamp,duration:meetingList.duration
            };
            storeMeetingPage(updatedInfo);
        }
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
    } catch (e) {
        console.error("Error in UpdateMeeting ", e);
    }
}

export const handelUpdateMeeting = (meetingList: any) => {
    console.log("handleUpdateMeeting >>>", meetingList)
    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        if (detailPage && meetingList.uuid === detailPage.uuid && currentWindowState === "meetingDetails") {
            storeMeetingPage(meetingList);
        }
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
    } catch (e) {
        console.error("Error in UpdateMeeting ", e);
    }
}

export const handelMeetingNotification = (meetingList: any) => {

    console.log("handelMeetingNotification >>>", meetingList);
    store.dispatch({
        type: Types.MEETING_NOTIFY,
        payloads: {
            meetingNotify: meetingList
        }
    });
}

export const handelAddParticipant = (meetingList: any) => {
    console.log("handle AddParticipant>>", meetingList);
    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        if (detailPage && meetingList.uuid === detailPage.uuid && currentWindowState === "meetingDetails") {
            let updatedInfo: any = detailPage;
            updatedInfo = {
                ...updatedInfo, participants: meetingList.participants
            };
            storeMeetingPage(updatedInfo);
        }
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
    } catch (e) {
        console.error("Error in AddParticipant", e);
    }
}

export const handelDeleteMeeting = (meetingList: any) => {
    console.log("handle Delete Meeting>>", meetingList)
    let { getListInput } = store.getState().meetingReducer;
    try {
        storeWindowState("mainPage");
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
    } catch (e) {
        console.error("Error in Delete Meeting", e);
    }
}

export const chatNotificationFlow = (inputOptions: any, fileDuraion: any) => {
    let fileRes: any = ""; let fileResText: any = ""; let titleRemove: boolean = false;
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let contactObject: any = store.getState().contactReducer;
    let { message } = inputOptions;
    let isForward = message?.message?.forward;

    //let time: any = moment(message?.message?.timestamp).format('MMMM Do, YYYY h:mm A');

    if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
        let msg = message?.message?.body;
        //let size = getFileSize(msg?.filesize);
        let file_duration = fileDuraion ? "(" + fileDuraion + ")" : "";
        //   let stickerWithTxt :any = msg?.text !== "" && (strickerFormat.indexOf(msg?.fileType) !== -1)  ? "\u{1f49f}" + " " + msg.text : msg?.text;
        let gifWithTxt: any = msg?.text !== "" && (gifFormat.indexOf(msg?.fileType) !== -1) ? "\u{1f3de}" + msg.text : msg?.text;
        let imageWithTxt: any = msg?.text !== "" && (imageFormat.indexOf(msg?.fileType) !== -1) ? "\u{1f4f7}" + msg.text : msg?.text;
        if (mp3Formats.indexOf(msg?.fileType) !== -1) {
            if (msg?.fileName === "me-at-thevoice.mp3" || msg?.fileType === "m4a") {
                fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the ' + `voice${file_duration} you sent` + '"' : isForward ? "\u{1f399} Shared this Voice" + file_duration + '"' : `${"\u{1f399}"} ${message.type === 2 ? "Voice " + file_duration : " Voice " + file_duration}`;
            } else {
                fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the audio you sent ' : isForward ? "\u{1f50a} Shared this audio " + file_duration : ` has sent you a audio ${"\u{1f50a}"} ${message.type === 2 ? " " : "  "}`;
            }
            fileResText = "\u{1f50a} Audio " + file_duration
        } else if ((gifFormat.indexOf(msg?.fileType) !== -1)) {
            fileRes = inputOptions.isLiked ? ' liked \u{1f44d} your GIF' : isForward ? "\u{1f3de} Shared this Gif" : !_.isUndefined(msg?.text) && msg?.text !== "" ? gifWithTxt : `  has sent you a GIF ${"\u{1f3de}"} ${message.type === 2 ? " " : "  "}`;
            fileResText = " \u{1f3de} GIF"
        } else if ((strickerFormat.indexOf(msg?.fileType) !== -1)) {
            fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the sticker you sent' : isForward ? "\u{1f383} Shared this Sticker" : !_.isUndefined(msg?.text) && msg?.text !== "" ? msg?.text : ` has sent you a Sticker ${"\u{1f383}"} ${message.type === 2 ? "" : "  "}`;
            fileResText = "\u{1f383} Sticker"
        } else if (imageFormat.indexOf(msg?.fileType) !== -1) {
            fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the photo you sent' : isForward ? "\u{1f4f7} Shared this photo" : !_.isUndefined(msg?.text) && msg?.text !== "" ? imageWithTxt : `  has sent you a image  ${"\u{1f4f7}"} ${message.type === 2 ? "" : " "}`;
            fileResText = "\u{1f4f7} Photo"
        } else if (videoFormat.indexOf(msg?.fileType) !== -1) {
            fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the video you sent ' : isForward ? "\u{1f4f9} Shared this video " + file_duration : !_.isUndefined(msg?.text) && msg?.text !== "" ? msg?.text : ` has sent you a video ${"\u{1f4f9}"} ${message.type === 2 ? " " : "  "}`;
            fileResText = "\u{1f4f9} Video " + file_duration
        } else {
            fileRes = inputOptions.isLiked ? ' liked \u{1f44d} the document you sent' : isForward ? "\u{1f4c4} Shared this document" : !_.isUndefined(msg?.text) && msg?.text !== "" ? msg?.text : ` has sent you a document ${"\u{1f4c4}"} ${message.type === 2 ? "" : ""}`;
            fileResText = "\u{1f4c4} Document"
        }
    }

    var title = `${message.type === 2 && isForward ? inputOptions?.id?.caller_id : inputOptions.userName}`;
    let { workContactsnew }: any = store.getState().contactReducer;
    let msgBody: any = (message?.message?.messageType === "AT_MENTION" || message?.message?.messageType === "TEXT") ? message?.message?.body?.replace(/(<([^>]+)>)|&nbsp;/gi, " ") : ""
    var textLength: any = message?.message?.body.length > 100 && !message?.message?.isLink ? msgBody.substring(0, 70) + "..." : msgBody;
    let groupFromCaller: any = inputOptions?.message?.type === 2 && !isForward ? inputOptions?.id?.caller_id + ": " : "";
    var name: any = message.message?.mentionID && message.message?.mentionID.toString().split(",");
    var MentionNamedetails: any = [];
    Array.isArray(name) && name.length > 0 &&
        name.forEach((el: any) => {
            MentionNamedetails.push(workContactsnew[el]?.caller_id);
        });
    let toCallerId: any = workContactsnew[parseInt(message?.message?.teamAction?.members)]?.caller_id;
    
    let taskStatus: any = message?.message?.body?.taskStatus === "In Review" || message?.message?.body?.taskStatus === "On Hold" ||
        message?.message?.body?.taskStatus === "In Progress" || message?.message?.body?.taskStatus === "Completed";
    let actionType = message?.message?.teamAction?.actionKey === "remove_member" && message?.message?.teamAction?.members === loggedUserDetails?.sip_login_id ? true : false;
    let who = '';
    const msgFrom = parseInt(message.from);
    const fromUser = parseInt(message.from);
    if (msgFrom === parseInt(loggedUserDetails.sip_login_id)) {
        who = 'You';
    } else {
        const fromCaller = contactObject.workContactsnew[fromUser];
        who = fromCaller?.caller_id;
    }
    let finalString = '';
    const members = message?.message?.teamAction?.members.toString().split(',');
    const finalMembers: any = Array.isArray(members) && members?.length > 0 && members.map((value: any) => {
        if (_.isUndefined(contactObject.workContactsnew[value]) === false) {
            const userD = contactObject.workContactsnew[value];
            return userD?.caller_id;
        } else {
            return []
        }
    });

    if (message?.message?.teamAction?.actionKey === "create_group") {
        finalString = who + ' ' + finalString + message?.message?.teamAction?.description;
        titleRemove = true
    } else if (message?.message?.teamAction?.actionKey === "remove_member") {
        finalString = who + " removed " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "add_member") {
        finalString = who + " added " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "make_admin") {
        finalString = who + " make as admin " + `${loggedUserDetails?.caller_id === toCallerId ? "you " : toCallerId}`
        //  message?.message?.teamAction?.description + finalMembers.join();
        // titleRemove = true
    } else if (message?.message?.teamAction?.actionKey === "make_member") {
        finalString = who + " make as member " +`${loggedUserDetails?.caller_id === toCallerId ? "you " : toCallerId}`
        //  message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "update_group") {
        finalString = who + " " + message?.message?.teamAction?.description + finalMembers.join();
        titleRemove = true
    } else if (message?.message?.teamAction?.actionKey === "leave_member") {
        finalString = who + " left the team " + finalMembers.join();
        titleRemove = true
    } else {
        finalString = who + ' ' + finalString + message?.message?.teamAction?.description + finalMembers;
    }
    let msgText: any =
        message?.message?.messageType === "TEXT" && message?.message?.isLink === false
            ? inputOptions.isLiked ? groupFromCaller + " liked \u{1f44d} your message " : isForward ? "  Forwarded this message" :  inputOptions?.GroupId?.team_id ? "" :" has messaged you"
            : message?.message?.messageType === "IMAGE" || message?.message?.messageType === "FILE"
                ? groupFromCaller + fileRes
                : message?.message?.teamAction?.actionKey === "create_group"
                    ? inputOptions?.id?.caller_id + ' created a new Private group'
                    : message?.message?.teamAction?.actionKey === "add_member"
                        ? inputOptions?.id?.caller_id + ' added ' + `${loggedUserDetails?.caller_id === toCallerId ? " you " : toCallerId}` 
                        // + ' to '  + inputOptions?.userName
                        : message?.message?.teamAction?.actionKey === "remove_member"
                            ? inputOptions?.id?.caller_id + ' removed ' + `${loggedUserDetails?.caller_id === toCallerId ? " you " : toCallerId}`
                            //  + ' from ' + inputOptions?.userName
                           : message?.message?.teamAction?.actionKey === "leave_member" ? inputOptions?.id?.caller_id + ' left the team '
                            : message?.message?.messageType === "GEO"
                                ? groupFromCaller + "\u{26f3} shared a location"
                                : message?.message?.messageType === "AT_MENTION"
                                    //  ? groupFromCaller+ `@ ${MentionNamedetails}`
                                    ? groupFromCaller + textLength
                                    : message?.message?.messageType === "TEXT" && message?.message?.isLink === true ? inputOptions.isLiked ? ` liked \u{1f44d} your message ` : message?.message?.isLink === true && isForward ? "\u{1f517} Shared this Link" : " has sent you a link "
                                        : message.message?.teamAction?.description.includes("edited the team description") ? `${inputOptions?.message?.type === 2 && !isForward && inputOptions?.id?.caller_id} changed the group description`
                                            : message?.message?.messageType === "NOTE"
                                                ? inputOptions.isLiked ? " liked \u{1f44d} the note you sent " : " has shared a notes with you"
                                                : message?.message?.messageType === "TASK"
                                                    ? inputOptions.isLiked ? " liked \u{1f44d} the task you were assigned " : message?.message?.isEdit === true || taskStatus ? " has updated a task " : " has assigned a task to you"
                                                    : message?.message?.messageType === "EVENTS"
                                                        ? inputOptions.isLiked ? " liked \u{1f44d} the event you were invited to " : message?.message?.isEdit === true ? " has updated an event " : " has invited you to an event"
                                                        : message?.message?.messageType === "BROADCAST" ? finalString : JSON.stringify(msgBody);

    let msgTitleText: any = message?.message?.messageType === "TEXT" && message?.message?.isLink === false ? (groupFromCaller + textLength) :
        message?.message?.messageType === "TEXT" && message?.message?.isLink === true ? " \u{1f517} " + (message?.message?.body.length > 100 ? msgBody.substring(0, 70) + "..." : msgBody) :
            message?.message?.messageType === "IMAGE" ? fileResText :
                message?.message?.messageType === "FILE" ? fileResText :
                    message?.message?.messageType === "TASK" ? " \u{1f4dd} " + message?.message?.body?.summary :
                        message?.message?.messageType === "EVENTS" ? " \u{1f4c6} " + message?.message?.body?.summary :
                            message?.message?.messageType === "NOTE" ? " \u{1f4cb} " + message?.message?.body?.summary :
                                titleRemove ? title :
                                    message?.message?.messageType === "BROADCAST" ? finalString : JSON.stringify(msgBody);


    inputOptions.message = message?.message?.teamAction?.actionKey === "add_member"
    ? inputOptions?.id?.caller_id + ' added ' + `${loggedUserDetails?.caller_id === toCallerId ? " you " : toCallerId}` : 
    message?.message?.teamAction?.actionKey === "remove_member"
    ? inputOptions?.id?.caller_id + ' removed ' + `${loggedUserDetails?.caller_id === toCallerId ? " you " : toCallerId}` :msgTitleText;
    inputOptions.userName = titleRemove ? "" : title;
    inputOptions.titleFetch = msgText;
    inputOptions.actionKey = actionType;
    inputOptions.type = actionType ? 'remove' : 'chat'
    showNotification(inputOptions, message);

};

export const getGroupCallInfo = (incomingInfo: any) => {
    try {
        if (!isEmpty(incomingInfo)) {
            let { GroupDetails, IndividualDetails, PSTNDetails } = incomingInfo || {};
            Object.keys(GroupDetails).forEach(function (ids) {
                Object.keys(GroupDetails[ids]).forEach(function (member) {
                    if (member !== "GroupName") {
                        GroupDetails[ids][member] = filterContactForCallNew(member.toString(), GroupDetails[ids][member], false, incomingInfo.Host)
                    }
                })
            })

            Object.keys(IndividualDetails).forEach(function (ids) {
                IndividualDetails[ids] = filterContactForCallNew(ids.toString(), IndividualDetails[ids], false, incomingInfo.Host);
            });

            Object.keys(PSTNDetails).forEach(function (ids) {
                PSTNDetails[ids] = filterContactForCallNew(ids.toString(), PSTNDetails[ids], false, incomingInfo.Host)
            });

            let newGroupInfo: any = {
                'GroupDetails': incomingInfo['GroupDetails'],
                'IndividualDetails': incomingInfo['IndividualDetails'],
                'PSTNDetails': incomingInfo['PSTNDetails']
            }

            let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
            let index: number = currentCallList.findIndex((e: any) => e.guid === incomingInfo['TeamID']);
            if (currentCallList[index] !== undefined) {
                currentCallList[index].groupCallInfo = newGroupInfo;
                currentCallList[index].isHostId = incomingInfo.Host;
                currentCallList[index].groupNames = incomingInfo.groupNames;
                currentCallList[index].isGroupCall = true;
                currentCallList[index].ImageURL=filterGrpProfile(Object.keys(currentCallList[index].groupNames));
                setActiveLogs(currentCallList[index]);
            }
        }
    } catch (error) {
        console.log('getGroupCallInfo error is -->>', error)
    }
}

export const setInitial=(val:any)=>{
    store.dispatch({
        type:Types.TIMER_STARTED,
        payloads:{
            isCallTimer:val
        }
    })
}

export const groupCallUserStatus = (incomingInfo: any) => {
    try {
        let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
        let index: number = currentCallList.findIndex((e: any) => e.guid === incomingInfo['TeamID']);
        let { GroupDetails, IndividualDetails, PSTNDetails } = currentCallList[index].groupCallInfo || {};

        if (currentCallList && (GroupDetails || IndividualDetails || PSTNDetails)) {
            Object.keys(GroupDetails).map((member: any) => {
                updateOldWithNewObj(GroupDetails[member], incomingInfo);
                // let activeUserInGrp:any=[];
                // Object.keys(GroupDetails[member]).map((user: any) => { 
                // let grouped:any= GroupDetails[member]
                // if(grouped[user].callStatus==='Connected'){
                //     activeUserInGrp.push(user)
                // }})

                // if(activeUserInGrp.length===1&&activeUserInGrp[0]===currentCallList[index].isHostId){
                //     delete GroupDetails[member];
                // }

                Object.keys(GroupDetails[member]).length === 1 && Object.keys(GroupDetails[member]).map((user: any) => {
                    if (user.toString() === currentCallList[index].isHostId) {
                        delete GroupDetails[member];
                    }
                })
            })
            
            updateOldWithNewObj(incomingInfo['userType'] === "Pstns" ? PSTNDetails : IndividualDetails, incomingInfo);
            store.dispatch({
                type: Types.UPDATDE_CALL_LIST,
                payloads: currentCallList
            });
            let {isCallTimer}=store.getState().callReducer
            if(!isCallTimer){
                startCallTime(incomingInfo.TeamID)
                setInitial(true)}

        }


    } catch (error) {
        console.log('groupCallUserStatus error is !!!', error)
    }
}

export const getTranscripts=(data:any)=>{
    let {audioTranscript,transcriptLoading,transcriptEnable}=store.getState().closeCaption;
    let {userdetails}=store.getState().loginReducer;
    
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    let contactDetail:any ={};
    if(data.speaker === userdetails.ext){
        contactDetail=userdetails;
    }
    else{companyContact.filter((user:any)=>{
        if(data.speaker === user.ext.toString()){contactDetail = user }
    })}
        
if((contactDetail!== null || contactDetail !== undefined) && data.text.trim() !== "")
      {let trans_data:any={...data};
      let duplicateIndex: any = _.findIndex(audioTranscript, {speaker: data.speaker});
          if(duplicateIndex > -1){
        let lastIndex =
        audioTranscript?.length >= 1 &&
        trans_data.speaker === audioTranscript[audioTranscript?.length - 1].speaker ? true: false;
        if(lastIndex){
          if(audioTranscript[audioTranscript?.length - 1]?.finalText?.length < 250){
                  let diff:any=250-audioTranscript[audioTranscript?.length - 1]?.finalText?.length;
                  const sentencePattern = /[^.!?]+[.!?]/g;
                  if(trans_data.text.length <= diff){
                    audioTranscript[audioTranscript.length - 1].finalText= audioTranscript[audioTranscript?.length - 1]?.finalText?.concat(" ",data.text)
                    // audioTranscript[audioTranscript.length - 1].finalconvertedText= audioTranscript[audioTranscript?.length - 1]?.finalconvertedText?.concat(" ",data.convertedText)
                    storeAudioTranscript(audioTranscript,transcriptLoading,transcriptEnable);
                  }
                  else{
                  if(trans_data.text?.match(sentencePattern))
                  {const meaningfulSentence = trans_data?.text?.match(sentencePattern)[0];
                    // const meaningFulConverted=trans_data.convertedText.match(sentencePattern)[0];
                      audioTranscript[audioTranscript?.length - 1].finalText= audioTranscript[audioTranscript?.length - 1]?.finalText?.concat(" ",meaningfulSentence)
                    //   audioTranscript[audioTranscript?.length - 1].finalconvertedText= audioTranscript[audioTranscript?.length - 1]?.finalconvertedText?.concat(" ",meaningFulConverted)
                    storeAudioTranscript(audioTranscript,transcriptLoading,transcriptEnable);
  
                      const remainingText = trans_data.text.slice(meaningfulSentence?.length).trim();
                    //   const remainingConvertedText =trans_data.convertedText.slice(meaningFulConverted?.length).trim();
                      if(remainingText ){
                                  trans_data.timeStamp=new Date().getTime();
                                  trans_data.finalText=remainingText;
                                  trans_data.speakerName=contactDetail.caller_id;
                                  trans_data.last_name=contactDetail.last_name;
                                  trans_data.first_name=contactDetail.first_name;
                                  trans_data.profileImg=contactDetail.profile_image_thumbnail;
                                //   trans_data.finalconvertedText=remainingConvertedText;
                                  audioTranscript.push(trans_data);
                                  storeAudioTranscript(audioTranscript,transcriptLoading,transcriptEnable);
                                }
                    }
                  }
        }
        else{
          trans_data.timeStamp=new Date().getTime();
          trans_data.finalText=data.text;
          trans_data.speakerName=contactDetail.caller_id;
          trans_data.last_name=contactDetail.last_name;
          trans_data.first_name=contactDetail.first_name;
          trans_data.profileImg=contactDetail.profile_image_thumbnail;
        //   trans_data.finalconvertedText=data.convertedText;
          audioTranscript.push(trans_data);
          storeAudioTranscript(audioTranscript,transcriptLoading,transcriptEnable);
        }
      }
      else{
        trans_data.timeStamp=new Date().getTime();
        trans_data.finalText=data.text;
        trans_data.last_name=contactDetail.last_name;
        trans_data.first_name=contactDetail.first_name;
        trans_data.speakerName=contactDetail.caller_id;
        trans_data.profileImg=contactDetail.profile_image_thumbnail;
        // trans_data.finalconvertedText=data.convertedText;
        audioTranscript.push(trans_data);
        storeAudioTranscript(audioTranscript,transcriptLoading,transcriptEnable);
      }
          }
          else{
            trans_data.timeStamp=new Date().getTime();
            trans_data.finalText=data.text;
            trans_data.last_name=contactDetail.last_name;
            trans_data.first_name=contactDetail.first_name;
            trans_data.speakerName=contactDetail.caller_id;
            trans_data.profileImg=contactDetail.profile_image_thumbnail;
            // trans_data.finalconvertedText=data.convertedText;
            audioTranscript.push(trans_data);
            storeAudioTranscript(audioTranscript,false,transcriptEnable);
          }
        }
}

export const storeAudioTranscript=(data:any,loading:any,enable:any)=>{
    let {autoDwld}=store.getState().closeCaption;
    store.dispatch({
        type: Types.AUDIO_CC,
        payload:  { audioTranscript: data,transcriptLoading:loading,transcriptEnable:enable,autoDwld:autoDwld }
    });
}

export const setAutoDwld=(data:any)=>{
    let {autoDwld,transcriptLoading,transcriptEnable,audioTranscript}=store.getState().closeCaption;
    store.dispatch({
        type: Types.AUDIO_CC,
        payload:  { audioTranscript: audioTranscript,transcriptLoading:transcriptLoading,transcriptEnable:transcriptEnable,autoDwld:data }
    });
}

export const initGroupInfo = (incomingInfo?: any) => {
    try {
        console.log("incomingInfo------->",incomingInfo)
        
        if ((incomingInfo['SwitchCallId']=== '' || incomingInfo['SwitchCallId']!== '')||incomingInfo['MergeCallId']) {
        let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
        let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
        let recording: any = store.getState().callPermissionDetail.recordingPermission || [];
        let isAutomaticRecord: boolean =
          recording['automatic_recording'] ? (recording['automatic_recording'].outbound && recording['automatic_recording'].is_auto_recording) : false;
        let index: number = currentCallList.findIndex((e: any) => (((e.guid === incomingInfo['SwitchCallId'] || e.switchCallId === incomingInfo['SwitchCallId']) && !e.isGroupCall)) || (incomingInfo['MergeCallId']!==''&& (e.guid === incomingInfo['TeamID']|| e.guid === incomingInfo['MergeCallId'] || e.switchCallId  === incomingInfo['MergeRequestId']||e.guid  === incomingInfo['MergeRequestId'] || e.switchCallId === incomingInfo['MergeCallId'])) );
        if (index !== -1) {
            let isInitiating:boolean=incomingInfo['MergeCallId']!==''?false:true;
            Object.keys(incomingInfo['GroupDetails']).forEach(function (ids) {
                Object.keys(incomingInfo['GroupDetails'][ids]).forEach(function (member) {
                    if (member !== "GroupName") {
                        incomingInfo['GroupDetails'][ids][member] = filterContactForCallNew(member.toString(), incomingInfo['GroupDetails'][ids][member], isInitiating, incomingInfo.Host)
                    }
                })
            })

            Object.keys(incomingInfo['IndividualDetails']).forEach(function (ids) {
                incomingInfo['IndividualDetails'][ids] = filterContactForCallNew(ids.toString(), incomingInfo['IndividualDetails'][ids], isInitiating, incomingInfo.Host);
            });

            Object.keys(incomingInfo['PSTNDetails']).forEach(function (ids) {
                incomingInfo['PSTNDetails'][ids] = filterContactForCallNew(ids.toString(), incomingInfo['PSTNDetails'][ids], isInitiating, incomingInfo.Host)
            });

            let newGroupInfo: any = {
                'GroupDetails': incomingInfo['GroupDetails'],
                'IndividualDetails': incomingInfo['IndividualDetails'],
                'PSTNDetails': incomingInfo['PSTNDetails']
            };
        if (incomingInfo['MergeRequestId'] !== '' || incomingInfo['MergeCallId'] !== '') {
               currentCallList[index].callAgentId=currentCallList[index].guid;
               var speechEvents: any;
               var options = { threshold: -50 };
            //    speechEvents = hark(currentCallList[index].localstream, options);
            //    detectActiveSpeaker(speechEvents, currentCallList[index].localstream);
            console.log('currentCallList[index].localstream',currentCallList[index].localstream);
        //    let newLocalStream:any= getLocalAudioStream();
        //     console.log('newLocalStreamnewLocalStreamnewLocalStream',newLocalStream);
        //     currentCallList[index].localstream=newLocalStream;
        //              speechEvents = hark(newLocalStream, options);
        //             detectActiveSpeaker(speechEvents, newLocalStream);  
        if (currentCallList[index] !== undefined) {
            currentCallList[index].groupCallInfo = newGroupInfo;
            if (incomingInfo['MergeRequestId'] !== '' || incomingInfo['MergeCallId'] !== ''){
                currentCallList[index].caller_id = getCombinedNames(incomingInfo, "callerId")
            }           
            currentCallList[index].isHostId = incomingInfo.Host;
            currentCallList[index].groupNames = incomingInfo.groupNames;
            currentCallList[index].switchCallId = (!currentCallList[index].switchCallId && incomingInfo['Host'].toString() === loggedUser.ext.toString()) ? incomingInfo['MergeRequestId'] : currentCallList[index].switchCallId;
            currentCallList[index].guid = incomingInfo['TeamID'];            
            currentCallList[index].isGroupCall=true;
            currentCallList[index].ImageURL=filterGrpProfile(Object.keys(currentCallList[index].groupNames));
            if(incomingInfo.hasOwnProperty("MergeCallId")){
                currentCallList[index].combinedNames=getCombinedNames(incomingInfo, "combinedNames");
            }
            if(incomingInfo['Host'].toString() === loggedUser.ext.toString()){
                currentCallList[index].isGroupHost = true;  
            }
            else{
                currentCallList[index].isGroupHost = false;   
            }  
            let {isCallTimer}=store.getState().callReducer; 
            setActiveLogs(currentCallList[index]);      
            store.dispatch({
                type: Types.UPDATDE_CALL_LIST,
                payloads: currentCallList
            });
            if(!isCallTimer){
                startCallTime(incomingInfo.TeamID)
                if(isAutomaticRecord)startRecordTimer(currentCallList[index].guid);
                setInitial(true)}
            } 
        }
        }
    } 
} catch (error) {
    console.log('--- initGroupInfo  error is ----',error);
    
}

   

}

export const groupCallMuteAll = (incomingInfo: any) => {
    let action: any = {};
    if (incomingInfo['action'] === undefined) {
        action = incomingInfo;
    }
    else {
        action = incomingInfo.action;
    }

    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let index: number = currentCallList.findIndex((e: any) => e.guid === action['TeamID']);



    if (index !== -1) {

        if (action.Status) {
            currentCallList[index].isMuteAll = action.Status === "muteAll" ? true : false;
        }
        const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
        let loggedExt: string = (loggedUser.ext)?.toString();
        let finalData: any = currentCallList[index].groupCallInfo || [];
        if (action.Status === "muteAll" || action.Status === "unmuteAll") {
            let switchMute: string = action.Status === 'muteAll' ? 'mute' : 'unmute';

            if (((currentCallList[index].isHostId)?.toString() !== loggedExt) ||
                Object.keys(incomingInfo).includes((loggedUser.ext).toString())) {
                muteGroupCall();
            }

            Object.keys(finalData['GroupDetails']).forEach(function (ids) {
                Object.keys(finalData['GroupDetails'][ids]).forEach(function (member) {
                    if ((currentCallList[index].isHostId)?.toString() !== member.toString()) {
                        finalData['GroupDetails'][ids][member].mute = switchMute;
                    }
                })
            })

            Object.keys(finalData['IndividualDetails']).forEach(function (ids) {
                if ((currentCallList[index].isHostId)?.toString() !== ids.toString()) {
                    finalData['IndividualDetails'][ids].mute = switchMute;
                }
            });

            Object.keys(finalData['PSTNDetails']).forEach(function (ids) {
                if ((currentCallList[index].isHostId)?.toString() !== ids.toString()) {
                    finalData['PSTNDetails'][ids].mute = switchMute;
                }
            });
            toastInformation(currentCallList[index].isGroupHost ? `You ${switchMute}d for all the participants` : `Host ${switchMute}d for all participants`, 'warning')
        }
        else {
            let { GroupDetails, IndividualDetails, PSTNDetails, hostId } = currentCallList[index].groupCallInfo || {};
            let isCurrentPresent = false;
            let updatedInfo = {};

            if (action.userType !== 'Group') {
                isCurrentPresent = action.userId === loggedExt;
                updatedInfo = setUserStausInGroupCall('mute', action.Status, action?.userId, currentCallList[index].groupCallInfo);

            }

            else {
                let GroupsUsers: Array<any> = Object.keys(finalData['GroupDetails'][action.userId])
                isCurrentPresent = GroupsUsers.includes(loggedExt);
                Object.keys(GroupDetails[action?.userId]).map((member: any) => {
                    updatedInfo = setUserStausInGroupCall('mute', action.Status, member, currentCallList[index].groupCallInfo);

                })
            }

            if (isCurrentPresent) {
                muteGroupCall();
                { (!currentCallList[index].isGroupHost && action.isHostDoer) && toastInformation(`Host ${action.Status}d for you`, 'warning') }
            }
            currentCallList[index].groupCallInfo = updatedInfo;
        }
        store.dispatch({
            type: Types.UPDATDE_CALL_LIST,
            payloads: currentCallList
        });
    }
}

export const groupCallEnd = (event: any) => {
    setInitial(false);
    let { activeLogs } = store.getState().callReducer || {};
    let allCallList: calldetail[] = store.getState().updatedCallList.callDetails || {};
    let idPos: number = activeLogs.findIndex(
        (ele: any) => (ele.guid === event.TeamID || ele.TeamID === event.TeamID)
    );
    let callIndex:any=allCallList.findIndex((ele:any)=>(ele.guid === event.TeamID || ele.TeamID === event.TeamID))
    if (idPos !== -1) {
        activeLogs.splice(idPos, 1);
        storeActiveLogs(activeLogs);
    }
    if(callIndex > -1){
        let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
        let history = window.location.href || "";
        let logExt = (loggeduser.ext).toString();
        let currentCalldetail: currentCallDetail = store.getState().updatedCallList || [];
       if(allCallList[callIndex].isHostId !== logExt){ allCallList.splice(callIndex, 1);
        store.dispatch({
            type: Types.CALL_END_WINDOW,
            payloads: {
              callDetails: allCallList,
              isWindowSlide: allCallList.length === 0 ? true : ((allCallList.length === 2 && currentCalldetail.isCallFullScreen) ? false : currentCalldetail.isWindowSlide),
              minimizedWindow: (history.includes('calls')) ? (allCallList.length > 1 ? true : false) : currentCalldetail.callDetails.length === 0 ? false : true,
              isCallFullScreen: (history.includes('calls')) ? (allCallList.length === 1 ? currentCalldetail.isCallFullScreen : false) : false,
              isCallActive: allCallList.length === 0 ? false : true,
              rightSideWindow: allCallList.length === 0 ? 'dialpad' : currentCalldetail.isCallActive ? 'participantList' : currentCalldetail.rightSideWindow,
              centerWindow: allCallList.length === 0 ? (currentCalldetail.leftSideWindow === 'callList') ? 'callDetail'
                : (currentCalldetail.leftSideWindow === 'voiceMail') ? 'voiceDetail'
                  : 'recordDetail' : 'callWindow',
              isTranscriptionOnOff: allCallList.length === 0 ? true : currentCalldetail.isTranscriptionOnOff
            }
          });
    }
   
    }
}

export const getRunningGroupCalls = (event: any) => {

    const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
    let loggedExt: string = (loggedUser.ext)?.toString();
    let { activeLogs } = store.getState().callReducer || {};

    event && event.length > 0 && event.map((leftCall: any) => {
        let activeIndex: number = activeLogs.findIndex((e: any) => (e.guid === leftCall.TeamID || e.TeamID === leftCall.TeamID));
        if (activeIndex === -1) {
            let { IndividualDetails, groupNames, PSTNDetails, GroupDetails } = leftCall || {};
            let callerName: string = '', combinedNames: Array<any> = [], singleStatus: any = {}, groupCallers: Array<any> = [], IndividualCallers: Array<any> = [];
            Object.keys(groupNames).forEach(element => {
                return groupCallers.push(groupNames[element]);
            });
            Object.keys(IndividualDetails).forEach(element => {
                let userValue: any = filterContact(element.toString());
                return IndividualCallers.push(userValue?.caller_id || element);
            });
            let alteredInfo: any = {
                'GroupDetails': GroupDetails || {},
                'IndividualDetails': IndividualDetails || {},
                'PSTNDetails': PSTNDetails || {}
            }
            let pstnCallers: Array<any> = Object.keys(PSTNDetails);
            combinedNames = combinedNames.concat(groupCallers);
            combinedNames = combinedNames.concat(pstnCallers);
            combinedNames = combinedNames.concat(IndividualCallers);
            callerName = combinedNames.toString();
            singleStatus['combinedNames'] = combinedNames || [];
            singleStatus['caller_id'] = callerName || '';
            singleStatus['callStatus'] = 'Rejoin';
            singleStatus['isHost'] = loggedExt === leftCall.Host;
            singleStatus['isHostId'] = leftCall.Host;
            singleStatus['connectingStatus'] = 'Connecting...';
            singleStatus['guid'] = leftCall.TeamID;
            singleStatus['groupCallInfo'] = alteredInfo;
            singleStatus['underGroups'] = {};
            activeLogs.push(singleStatus);
        }
        storeActiveLogs(activeLogs);

    })

}

export const grpCallSpeechStatus = (incomingInfo: any) => {
    try {
        let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
        let index: number = currentCallList.findIndex((e: any) => e.guid === incomingInfo['TeamID']);
        let { GroupDetails, IndividualDetails } = currentCallList[index].groupCallInfo || {};

        if (currentCallList && (GroupDetails || IndividualDetails)) {
            setUserStausInGroupCall('isSpeaking', incomingInfo.isSpeaking, incomingInfo?.user, currentCallList[index].groupCallInfo);

            store.dispatch({
                type: Types.UPDATDE_CALL_LIST,
                payloads: currentCallList
            });
        }


    } catch (error) {
        console.log('grpCallSpeechStatus error is !!!', error)
    }
}

export const missedLog = () => {
    let { logsInput } = store.getState().callReducer || [];
    let { leftSideWindow } = store.getState().updatedCallList;
    if (leftSideWindow === 'callList') { getCallLogsCDR(logsInput.offset, logsInput.filter, logsInput.search); }
}

export const syncDeleteLog = () => {
    let { logsInput } = store.getState().callReducer || [];
    let { leftSideWindow } = store.getState().updatedCallList;
    if (leftSideWindow === 'callList') { getCallLogsCDR(logsInput.offset, logsInput.filter, logsInput.search); }
}

export const incomingLog = () => {
    let { logsInput } = store.getState().callReducer || [];
    let { leftSideWindow } = store.getState().updatedCallList;
    if (leftSideWindow === 'callList') { getCallLogsCDR(logsInput.offset, logsInput.filter, logsInput.search); }
}

export const outgoingLog = () => {
    let { logsInput } = store.getState().callReducer || [];
    let { leftSideWindow } = store.getState().updatedCallList;
    let {transcriptEnable}=store.getState().closeCaption;
    if (leftSideWindow === 'callList') { getCallLogsCDR(logsInput.offset, logsInput.filter, logsInput.search); }
    // storeAudioTranscript([],true,false);
}


export const updatingHost = (incomingInfo: any) => {
    if (!isEmpty(incomingInfo)) {
        let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
        let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
        let index: number = currentCallList.findIndex((e: any) => e.guid === incomingInfo['TeamID']);
        if (currentCallList[index] !== undefined) {
            if ((loggedUserDetails.ext).toString() === incomingInfo.Host) {
                currentCallList[index].isGroupHost = true;
                toastInformation(`You're assigned as Host`, 'success')
            } else {
                currentCallList[index].isGroupHost = false;
            }
            currentCallList[index].isHostId = incomingInfo.Host;
            setActiveLogs(currentCallList[index]);
            store.dispatch({
                type: Types.UPDATDE_CALL_LIST,
                payloads: currentCallList
            });
        }
    }
};
export const flipCall = (incomingInfo: any) => {
    let { activeLogs } = store.getState().callReducer || {};

    
    let flipIndex = activeLogs.findIndex((e: any) => e.guid === incomingInfo.callId|| e.guid === incomingInfo.uid);

    if (flipIndex >= 0) {
        activeLogs[flipIndex]['connectingStatus'] = 'Flip';
        storeActiveLogs(activeLogs);
    }
};

export const callConnected = (oncalls: any) => {
    console.log("merge call connected");

    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];

    let { activeLogs }: any = store.getState().callReducer || {};
    let {rightSideWindow}=store.getState().updatedCallList;

    let {transcriptLoading,audioTranscript}:any=store.getState().closeCaption;


    let ongoingIndex: number = activeLogs.findIndex((e: any) => e.guid === oncalls.uid ||e.switchCallId===oncalls.oldFromCallId ||e.switchCallId === oncalls.oldToCallId   || e.guid===oncalls.oldFromCallId||e.guid===oncalls.oldToCallId );

    const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
    let { from, to, fromDeviceType, toDeviceType } = oncalls;
    let loggedExt: string = (loggedUser.ext)?.toString();
    let opponentExt: string = loggedExt === from ? to : from;
    let currentDevice: string = loggedExt === to ?  toDeviceType : fromDeviceType


    if (currentDevice !== "URWEB:WEB" && (oncalls.status === "ongoing"||oncalls.status=== "update_session_info") && ongoingIndex === -1) {
        let singleStatus: any = {}
        let userValue: any = filterContact(opponentExt);
        singleStatus['combinedNames'] = [];
        singleStatus['caller_id'] = userValue?.caller_id || '';
        singleStatus['callStatus'] = 'On a call';
        singleStatus['opponentExt'] = opponentExt;
        singleStatus['opponentSip'] = userValue?.sip_login_id;
        singleStatus['connectingStatus'] = '';
        // if (oncalls.status=== "update_session_info") {
        //     singleStatus['guid'] =loggedExt === from ? oncalls.oldFromCallId: oncalls.oldToCallId;
        // } else {
            singleStatus['guid'] = oncalls.uid;
        // // }

        singleStatus['todeviceType'] = oncalls.toDeviceType;
        singleStatus['fromdeviceType'] = oncalls.fromDeviceType;
        singleStatus['callduration'] = "00:00:00";
        singleStatus['switchCallId']=loggedExt === to ?  oncalls.oldToCallId : oncalls.oldFromCallId;

        activeLogs.push(singleStatus);
        startCallTime(oncalls.uid);
        storeActiveLogs(activeLogs);
        if(oncalls.status === "disconnected"){storeAudioTranscript([],true,true);}
        frameCallProfile(singleStatus);

    }else if(oncalls.status=== "update_session_info"&&ongoingIndex !== -1){
        activeLogs[ongoingIndex].guid=oncalls.uid;
        activeLogs[ongoingIndex].switchCallId=loggedExt === to ?  oncalls.toDeviceType : oncalls.fromDeviceType;
        if(currentDevice !== "URWEB:WEB"){
            activeLogs[ongoingIndex]['callStatus'] = 'On a call';
        }
    }

    else if ((oncalls.status === 'disconnected'||oncalls.status ==="single_session_disconnect") && ongoingIndex !== -1) {
        activeLogs.splice(ongoingIndex, 1)

    }
    store.dispatch({
        type: Types.FLIP_CALL_CONNECTED,
        payloads: {
            filpcallConnected: oncalls
        }
    })


};



export const handleCompletedMeeting = (meetingList: any) => {
    console.log("handle Completed>>", meetingList);
    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        if (detailPage && meetingList.meetingId === detailPage.uuid && currentWindowState === "meetingDetails") {
            let updatedInfo: any = detailPage;
            updatedInfo = {
                ...updatedInfo, status: "Completed"
            };
            storeMeetingPage(updatedInfo);
        }
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        let recdata: any ={};
        recdata.offset = 0;
        recdata.limit = 10;
        recdata.search = "";
        getVideoRecordingLists(recdata);
    } catch (e) {
        console.error("Error in AddParticipant", e);
    }
}

export const MeetingStatusRead = (data:any) =>{
    
    let meetingReducer: any = store.getState().meetingReducer;
    const {meetingCountStatus} =meetingReducer;
    if(!meetingCountStatus){
        store.dispatch({
            type: Types.VIDEOMEET_COUNT_STATUS,
            payload: {
              meetingCountStatus:true
            }
          })
        updateMeetingRead(data?.uuid);
    }  else{

        store.dispatch({
            type: Types.VIDEOMEET_COUNT_STATUS,
            payload: {
              meetingCountStatus:false
            }
          })
    }   
}

export const handleOngoingMeeting = (meetingList: any) => {
    console.log("handle cancel>>", meetingList);
    let { getListInput, detailPage, currentWindowState } = store.getState().meetingReducer;
    try {
        let data: any = {};
        data.offset = 0;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        getMeetingLists(data);
        getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
        if (detailPage && meetingList.meetingId === detailPage.uuid && currentWindowState === "meetingDetails") {
            let updatedInfo: any = detailPage;
            updatedInfo = {
                ...updatedInfo, status: "Ongoing Meeting"
            };
            storeMeetingPage(updatedInfo);
        }
    } catch (e) {
        console.error("Error in ongoing", e);
    }

}

export const saverecordlist =(recordlist:any)=>{
      store.dispatch({
            type: Types.RECORD_DETAIL_PAGE,
            payload: { recordDetailPage: recordlist }
          });
}

export const shareRedux =(sharedetails:any,sharemodal:any)=>{
    store.dispatch({
          type: Types.REC_SHARE,
          payload: { shareDetails: sharedetails,
              recShare:sharemodal }
        });
}
